// This code was generated by a tool. Do not edit manually.
import { BaseClient, createRequestInit } from './GraphQL.BaseClient';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Byte: number;
  Char: string;
  DateTime: Date;
  Decimal: number;
  Long: number;
  Short: number;
}

export interface AccountInputModel {
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']>;
  acceptPromotions?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirm?: InputMaybe<Scalars['String']>;
  securityQuestion?: InputMaybe<Scalars['Int']>;
  securityQuestionAnswer?: InputMaybe<Scalars['String']>;
}

export interface AccountViewModel {
  email?: Maybe<Scalars['String']>;
  origin: LoanApplicationOrigin;
  redirectUrl?: Maybe<Scalars['String']>;
  securityQuestions?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  showInviteExpired: Scalars['Boolean'];
  showSecurityIconsAndMessage: Scalars['Boolean'];
}

export interface AddressModel {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface AddressModelInput {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

export interface BankInputModel {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankAccountNumberVerify?: InputMaybe<Scalars['String']>;
  bankInstitutionNumber?: InputMaybe<Scalars['String']>;
  bankTransitNumber?: InputMaybe<Scalars['String']>;
  bin?: InputMaybe<Scalars['String']>;
  bridgePayPermanentToken?: InputMaybe<Scalars['String']>;
  cardExpiry?: InputMaybe<Scalars['DateTime']>;
  cardTestDisabled?: InputMaybe<Scalars['Boolean']>;
  cardTestResult?: InputMaybe<Scalars['Short']>;
  cardToken?: InputMaybe<Scalars['Int']>;
  lastFour?: InputMaybe<Scalars['String']>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  useHomeAddressForCard?: InputMaybe<Scalars['Boolean']>;
}

export interface BankVerificationFailResult {
  canUseElectronicPaystub: Scalars['Boolean'];
  canUsePictureUtility: Scalars['Boolean'];
  incomeNeedsVerified: Scalars['Boolean'];
  loanApplicationKey: Scalars['Int'];
  pictureUtilityDownloadUrl?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
}

export interface BankVerificationViewModel {
  flinksConnectUrl?: Maybe<Scalars['String']>;
}

export interface BankViewModel {
  bankAccountNumber?: Maybe<Scalars['String']>;
  bankAccountNumberVerify?: Maybe<Scalars['String']>;
  bankInstitutionNumber?: Maybe<Scalars['String']>;
  bankTransitNumber?: Maybe<Scalars['String']>;
  bin?: Maybe<Scalars['String']>;
  bridgePayPermanentToken?: Maybe<Scalars['String']>;
  canAddCard: Scalars['Boolean'];
  canFundToDebitCard: Scalars['Boolean'];
  cardExpiry?: Maybe<Scalars['DateTime']>;
  cardToken: Scalars['Int'];
  hasCardOnFile: Scalars['Boolean'];
  homeAddress?: Maybe<AddressModel>;
  inLoanAppReview: Scalars['Boolean'];
  isDebitCardRequired: Scalars['Boolean'];
  lastFour?: Maybe<Scalars['String']>;
  loanType: LoanType;
  matchedCustomer?: Maybe<MatchedCustomerModel>;
  nameOnCard?: Maybe<Scalars['String']>;
  origin: LoanApplicationOrigin;
  paperlessBillingEnabled: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
  state: State;
  useHomeAddressForCard: Scalars['Boolean'];
}

export enum BulletType {
  Bullet = 'BULLET',
  CheckMark = 'CHECK_MARK',
  None = 'NONE'
}

export enum BusinessLegalType {
  /** Corporation */
  Corporation = 'CORPORATION',
  /** LLC */
  Llc = 'LLC',
  /** LLP */
  Llp = 'LLP',
  /** LP */
  Lp = 'LP',
  None = 'NONE',
  /** Other */
  Other = 'OTHER',
  /** Partnership */
  Partnership = 'PARTNERSHIP',
  /** Sole Proprietorship */
  SoleProprietorship = 'SOLE_PROPRIETORSHIP'
}

export interface BusinessLoanDisplayModel {
  currentAddress?: Maybe<AddressModel>;
  redirectUrl?: Maybe<Scalars['String']>;
  validationMessage?: Maybe<Scalars['String']>;
}

export interface BusinessLoanInputModel {
  address?: InputMaybe<AddressModelInput>;
  businessName?: InputMaybe<Scalars['String']>;
  businessTypeCode?: InputMaybe<BusinessType>;
  legalTypeCode?: InputMaybe<BusinessLegalType>;
  loanPurpose?: InputMaybe<Scalars['String']>;
  numberOfEmployees?: InputMaybe<Scalars['Short']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  taxIdNum?: InputMaybe<Scalars['String']>;
  useHomeAddress?: InputMaybe<Scalars['Boolean']>;
  verifiedBankDeposits?: InputMaybe<Scalars['Decimal']>;
  verifiedMonthlyNetIncome?: InputMaybe<Scalars['Decimal']>;
}

export enum BusinessType {
  /** Construction */
  Construction = 'CONSTRUCTION',
  /** Consulting */
  Consulting = 'CONSULTING',
  /** Education */
  Education = 'EDUCATION',
  /** Finance */
  Finance = 'FINANCE',
  /** Health */
  Health = 'HEALTH',
  /** Manufacturing */
  Manufacturing = 'MANUFACTURING',
  None = 'NONE',
  /** Other */
  Other = 'OTHER',
  /** Retail */
  Retail = 'RETAIL',
  /** Service */
  Service = 'SERVICE',
  /** Wholesale */
  Wholesale = 'WHOLESALE'
}

export enum ButtonType {
  Button = 'BUTTON',
  Link = 'LINK',
  None = 'NONE'
}

export interface CommunicationConsentInputModel {
  consentElectronicDisclosure?: InputMaybe<Scalars['Boolean']>;
  consentPromotionalCallsAndSMS?: InputMaybe<Scalars['Boolean']>;
  homePhone?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
}

export interface ConfirmNoCardModel {
  canFundToDebitCard: Scalars['Boolean'];
}

export interface CreditAgency {
  address?: Maybe<Scalars['String']>;
  agencyMasterKey: Scalars['Int'];
  asXml?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  consumerContactName?: Maybe<Scalars['String']>;
  creditScore: Scalars['Decimal'];
  creditScoreBeginRange: Scalars['Decimal'];
  creditScoreEndRange: Scalars['Decimal'];
  isCreditReportingAgency: Scalars['Boolean'];
  isCreditScore: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  websiteAddress?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface CuroDodDualAuthModel {
  customerKey: Scalars['Int'];
  loanProductConfigKey: Scalars['Int'];
}

export interface DateModel {
  assumeLastDayOfMonth?: Maybe<Scalars['Boolean']>;
  base?: Maybe<Scalars['DateTime']>;
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
}

export interface DateModelInput {
  assumeLastDayOfMonth?: InputMaybe<Scalars['Boolean']>;
  base?: InputMaybe<Scalars['DateTime']>;
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export interface DeniedViewModel {
  applyForPaydayLoanUrl?: Maybe<Scalars['String']>;
  googleMapsApiKey?: Maybe<Scalars['String']>;
  isNearStore: Scalars['Boolean'];
  isNonMarketState: Scalars['Boolean'];
  isRapidCash: Scalars['Boolean'];
  isRestrictedState: Scalars['Boolean'];
  isStateDeclined: Scalars['Boolean'];
  itemsForStoreLoans?: Maybe<Array<Maybe<Scalars['String']>>>;
  offerPaydayLoan: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
  stateCodeFromApp?: Maybe<Scalars['String']>;
  stateDeniedText?: Maybe<Scalars['String']>;
  storeAddressCity?: Maybe<Scalars['String']>;
  storeAddressLine1?: Maybe<Scalars['String']>;
  storeAddressLine2?: Maybe<Scalars['String']>;
  storeAddressLine3?: Maybe<Scalars['String']>;
  storeAddressState?: Maybe<Scalars['String']>;
  storeAddressZipCode?: Maybe<Scalars['String']>;
  storeCrossStreets?: Maybe<Scalars['String']>;
  storeDirectionsUrl?: Maybe<Scalars['String']>;
  storeHours?: Maybe<Scalars['String']>;
  storeLatitude: Scalars['Float'];
  storeLocationsUrl?: Maybe<Scalars['String']>;
  storeLongitude: Scalars['Float'];
  storeName?: Maybe<Scalars['String']>;
  storePhone?: Maybe<Scalars['String']>;
}

export interface DisclosureModel {
  agree: Scalars['Boolean'];
  content?: Maybe<Scalars['String']>;
  documentContent?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  help?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  index: Scalars['Short'];
  moreThanOneInstallmentPlan?: Maybe<Scalars['String']>;
  needsRead?: Maybe<Scalars['Boolean']>;
  radioOptions?: Maybe<Array<Maybe<StringBooleanKeyValuePairGraphType>>>;
  required: Scalars['Boolean'];
  requiredValue?: Maybe<Scalars['String']>;
  selectedValue?: Maybe<Scalars['String']>;
  subHeader?: Maybe<Scalars['String']>;
  validation?: Maybe<Scalars['String']>;
}

export interface DisclosureModelInput {
  agree?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Scalars['String']>;
  documentContent?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Short']>;
  moreThanOneInstallmentPlan?: InputMaybe<Scalars['String']>;
  needsRead?: InputMaybe<Scalars['Boolean']>;
  radioOptions?: InputMaybe<Array<InputMaybe<StringBooleanKeyValuePairInputGraphType>>>;
  required?: InputMaybe<Scalars['Boolean']>;
  requiredValue?: InputMaybe<Scalars['String']>;
  selectedValue?: InputMaybe<Scalars['String']>;
  subHeader?: InputMaybe<Scalars['String']>;
  validation?: InputMaybe<Scalars['String']>;
}

export interface DiscountCodeResult {
  isValid: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
}

export interface DiscountCodeViewModel {
  code?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
}

export interface DiscountCodeViewModelInput {
  code?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
}

export interface DocumentListModel {
  currentState: State;
  documents?: Maybe<Array<Maybe<DocumentModel>>>;
  exitPromptEnabled: Scalars['Boolean'];
  fullNameMatch?: Maybe<Scalars['String']>;
  isInsuredProduct: Scalars['Boolean'];
  name?: Maybe<NameModel>;
  phone?: Maybe<Scalars['String']>;
  phoneListItems?: Maybe<Array<Maybe<SelectListItem>>>;
  redirectUrl?: Maybe<Scalars['String']>;
  refinanceLoanKey: Scalars['Int'];
  signatures?: Maybe<Array<Maybe<Scalars['String']>>>;
  subheading?: Maybe<Scalars['String']>;
}

export interface DocumentListModelInput {
  currentState?: InputMaybe<State>;
  documents?: InputMaybe<Array<InputMaybe<DocumentModelInput>>>;
  exitPromptEnabled?: InputMaybe<Scalars['Boolean']>;
  fullNameMatch?: InputMaybe<Scalars['String']>;
  isInsuredProduct?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<NameModelInput>;
  phone?: InputMaybe<Scalars['String']>;
  phoneListItems?: InputMaybe<Array<InputMaybe<SelectListItemInput>>>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  refinanceLoanKey?: InputMaybe<Scalars['Int']>;
  signatures?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subheading?: InputMaybe<Scalars['String']>;
}

export interface DocumentModel {
  documentIndex: Scalars['Int'];
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  isMarketingConsent: Scalars['Boolean'];
  isMilitaryDoc: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  noSignatureAction: NoSignatureAction;
  required: Scalars['Boolean'];
  showSignatureCheckbox: Scalars['Boolean'];
  signatureLabel?: Maybe<Scalars['String']>;
  visible: Scalars['Boolean'];
}

export interface DocumentModelInput {
  documentIndex?: InputMaybe<Scalars['Int']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  isMilitaryDoc?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noSignatureAction?: InputMaybe<NoSignatureAction>;
  required?: InputMaybe<Scalars['Boolean']>;
  showSignatureCheckbox?: InputMaybe<Scalars['Boolean']>;
  signatureLabel?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
}

export interface DynamicContent {
  action?: Maybe<Scalars['String']>;
  bulletType?: Maybe<BulletType>;
  buttonType?: Maybe<ButtonType>;
  height?: Maybe<Scalars['Int']>;
  icon?: Maybe<IconType>;
  id: Scalars['Int'];
  parentId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  style?: Maybe<ViewStyle>;
  target?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  textStyle?: Maybe<TextStyle>;
  type: NodeType;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
}

export interface EmailValidationModel {
  emailSuggestion?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
  validationMessage?: Maybe<Scalars['String']>;
}

export enum FontStyle {
  Italic = 'ITALIC',
  Normal = 'NORMAL'
}

export enum FontWeight {
  Bold = 'BOLD',
  Normal = 'NORMAL'
}

export enum FuelType {
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Gas = 'GAS',
  Hybrid = 'HYBRID',
  None = 'NONE',
  Other = 'OTHER',
  Propane = 'PROPANE'
}

export enum Housing {
  None = 'NONE',
  Own = 'OWN',
  Rent = 'RENT'
}

export enum IconType {
  BackArrow = 'BACK_ARROW',
  Bank = 'BANK',
  Camera = 'CAMERA',
  Check = 'CHECK',
  Email = 'EMAIL',
  Home = 'HOME',
  None = 'NONE',
  Phone = 'PHONE',
  Pin = 'PIN'
}

export interface IdentificationInputModel {
  identificationCountry?: InputMaybe<Scalars['String']>;
  identificationExpiryDay?: InputMaybe<Scalars['Int']>;
  identificationExpiryMonth?: InputMaybe<Scalars['Int']>;
  identificationExpiryYear?: InputMaybe<Scalars['Int']>;
  identificationNumber?: InputMaybe<Scalars['String']>;
  identificationState?: InputMaybe<Scalars['String']>;
  identificationTypeKey?: InputMaybe<Scalars['Int']>;
  isIdentificationNonExpiry?: InputMaybe<Scalars['Boolean']>;
}

export interface IdentificationTypeModel {
  description?: Maybe<Scalars['String']>;
  key: Scalars['Int'];
  requireCountry: Scalars['Boolean'];
  requireExpiry: Scalars['Boolean'];
  requireNumber: Scalars['Boolean'];
  requireState: Scalars['Boolean'];
}

export interface IdentificationViewModel {
  countries?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  identificationCountry?: Maybe<Scalars['String']>;
  identificationExpiry?: Maybe<Scalars['DateTime']>;
  identificationNumber?: Maybe<Scalars['String']>;
  identificationState?: Maybe<Scalars['String']>;
  identificationTypeKey?: Maybe<Scalars['Int']>;
  identificationTypes?: Maybe<Array<Maybe<IdentificationTypeModel>>>;
  inLoanAppReview: Scalars['Boolean'];
  isIdentificationNonExpiry: Scalars['Boolean'];
  origin: LoanApplicationOrigin;
  redirectUrl?: Maybe<Scalars['String']>;
  statesWithPotentialNonExpiryId?: Maybe<Array<Maybe<Scalars['String']>>>;
}

export enum IncomeCalculationCycle {
  Monthly = 'MONTHLY',
  None = 'NONE',
  PerPaycheck = 'PER_PAYCHECK'
}

export interface IncomeModel {
  bimonthlyPayday?: Maybe<TwiceMonthlyPayday>;
  directDeposit?: Maybe<Scalars['Boolean']>;
  employerName?: Maybe<Scalars['String']>;
  firstBimonthlyPayday?: Maybe<Scalars['Int']>;
  grossPay?: Maybe<Scalars['Decimal']>;
  hireDate?: Maybe<Scalars['DateTime']>;
  incomeFrequency?: Maybe<IncomeCalculationCycle>;
  incomeSource: Scalars['Int'];
  incomeTypeCode?: Maybe<Scalars['String']>;
  jobTypeKey?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['Int']>;
  lastBiweeklyPayDate?: Maybe<Scalars['DateTime']>;
  monthlyGrossPay: Scalars['Decimal'];
  monthlyNetPay: Scalars['Decimal'];
  netPay?: Maybe<Scalars['Decimal']>;
  nextMonthlyPayDate?: Maybe<Scalars['DateTime']>;
  nextMonthlyPayDateMethod?: Maybe<NextMonthlyPayDateMethod>;
  nextPayDate: Scalars['DateTime'];
  payCycle?: Maybe<PayCycle>;
  payCycleMonthInterval: PayCycleMonthInterval;
  payCycleSummary?: Maybe<Scalars['String']>;
  periodicPay?: Maybe<Array<Maybe<PeriodicPayModel>>>;
  periodicPayRequired?: Maybe<Scalars['Boolean']>;
  secondBimonthlyPayday?: Maybe<Scalars['Int']>;
  weeklyPayday?: Maybe<DayOfWeek>;
  workAddress?: Maybe<AddressModel>;
  workPhone?: Maybe<Scalars['String']>;
}

export interface IncomeModelInput {
  bimonthlyPayday?: InputMaybe<TwiceMonthlyPayday>;
  directDeposit?: InputMaybe<Scalars['Boolean']>;
  employerName?: InputMaybe<Scalars['String']>;
  firstBimonthlyPayday?: InputMaybe<Scalars['Int']>;
  grossPay?: InputMaybe<Scalars['Decimal']>;
  hireDate?: InputMaybe<Scalars['DateTime']>;
  incomeFrequency?: InputMaybe<IncomeCalculationCycle>;
  incomeSource?: InputMaybe<Scalars['Int']>;
  incomeTypeCode?: InputMaybe<Scalars['String']>;
  jobTypeKey?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['Int']>;
  lastBiweeklyPayDate?: InputMaybe<Scalars['DateTime']>;
  monthlyGrossPay?: InputMaybe<Scalars['Decimal']>;
  monthlyNetPay?: InputMaybe<Scalars['Decimal']>;
  netPay?: InputMaybe<Scalars['Decimal']>;
  nextMonthlyPayDate?: InputMaybe<Scalars['DateTime']>;
  nextMonthlyPayDateMethod?: InputMaybe<NextMonthlyPayDateMethod>;
  nextPayDate?: InputMaybe<Scalars['DateTime']>;
  payCycle?: InputMaybe<PayCycle>;
  payCycleMonthInterval?: InputMaybe<PayCycleMonthInterval>;
  payCycleSummary?: InputMaybe<Scalars['String']>;
  periodicPay?: InputMaybe<Array<InputMaybe<PeriodicPayModelInput>>>;
  periodicPayRequired?: InputMaybe<Scalars['Boolean']>;
  secondBimonthlyPayday?: InputMaybe<Scalars['Int']>;
  weeklyPayday?: InputMaybe<DayOfWeek>;
  workAddress?: InputMaybe<AddressModelInput>;
  workPhone?: InputMaybe<Scalars['String']>;
}

export interface IncomeViewModel {
  incomeSourceOptions?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  incomeTypeOptions?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  incomeVerificationTypes?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  jobTypeOptions?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  origin: LoanApplicationOrigin;
  payCycleOptions?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  redirectUrl?: Maybe<Scalars['String']>;
  twiceMonthlyPaydayOptions?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
}

export interface IndividualScheduledPaymentsModel {
  enrollAllPayments: Scalars['Boolean'];
  name?: Maybe<NameModel>;
  optionalLoanPaymentAuthorizationDocUrl?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
  scheduledPayments?: Maybe<Array<Maybe<ScheduledPaymentModel>>>;
}

export interface IndividualScheduledPaymentsModelInput {
  enrollAllPayments?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<NameModelInput>;
  optionalLoanPaymentAuthorizationDocUrl?: InputMaybe<Scalars['String']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  scheduledPayments?: InputMaybe<Array<InputMaybe<ScheduledPaymentModelInput>>>;
}

export interface InstallmentLoanOptionModel {
  apr: Scalars['Decimal'];
  cashAmount: Scalars['Decimal'];
  loanLength: Scalars['Int'];
  nextDueAmount: Scalars['Decimal'];
}

export interface Int32StringKeyValuePairGraphType {
  key: Scalars['Int'];
  value: Scalars['String'];
}

export enum LanguageType {
  /** English */
  English = 'ENGLISH',
  /** French */
  French = 'FRENCH',
  /** None */
  None = 'NONE',
  /** Spanish */
  Spanish = 'SPANISH'
}

export interface LoanApplicationInfo {
  customerKey: Scalars['Int'];
  isLoanByPhone: Scalars['Boolean'];
  loanApplicationKey: Scalars['Int'];
  scoreResults?: Maybe<Array<Maybe<ScoreResults>>>;
  status: Scalars['Int'];
  visitorKey: Scalars['Int'];
}

export interface LoanApplicationMutations {
  acceptDisclosures?: Maybe<Scalars['String']>;
  acceptMarketingInvitation?: Maybe<Scalars['Boolean']>;
  appReviewAcceptMarketingInvitation?: Maybe<Scalars['Boolean']>;
  appReviewDeclineMarketingInvitation?: Maybe<Scalars['Boolean']>;
  applyDiscountCode?: Maybe<DiscountCodeResult>;
  clearDeniedLoanApplicationCache?: Maybe<Scalars['Boolean']>;
  createNew?: Maybe<NewLoanApplicationResult>;
  declineMarketingInvitation?: Maybe<Scalars['Boolean']>;
  getNonMarketLocation: Scalars['Boolean'];
  logBankNotSupported: Scalars['Int'];
  outOfWalletSave?: Maybe<OutOfWalletSaveResult>;
  persistAccountInputModel?: Maybe<AccountViewModel>;
  persistBankInputModel?: Maybe<BankViewModel>;
  persistBankVerificationLoginDetails: Scalars['Boolean'];
  persistBusinessLoanModel?: Maybe<BusinessLoanDisplayModel>;
  persistCommunicationConsentInputModel: Scalars['Boolean'];
  persistIdentificationInputModel?: Maybe<IdentificationViewModel>;
  persistOowForTestLoan?: Maybe<Scalars['String']>;
  persistOowForTestLoanApplication?: Maybe<Scalars['String']>;
  persistOptionalPaymentAuthorizationNoThanks?: Maybe<OptionalPaymentAuthorizationViewModel>;
  persistPaystubInputModel?: Maybe<PaystubViewModel>;
  persistPersonalInputModel?: Maybe<PersonalViewModel>;
  persistReservationInputModel?: Maybe<ReservationViewModel>;
  persistReviewInputModel?: Maybe<ReviewViewModel>;
  persistSelectTermsInputModel?: Maybe<Scalars['String']>;
  persistVehicleInputs?: Maybe<VehicleViewModel>;
  persistVehicleLienHolderInputs?: Maybe<VehicleLienHolderInputModel>;
  preLoanAppDisclosures?: Maybe<PreLoanAppDisclosuresResult>;
  preLoanAppDisclosuresRedirect?: Maybe<PreLoanAppDisclosuresRedirectResult>;
  saveBankInputModel?: Maybe<BankViewModel>;
  savePersonalInputModel?: Maybe<PersonalViewModel>;
  saveProductSelection?: Maybe<ProductSelectionSaveResult>;
  skPreLoanAppDisclosures?: Maybe<SkPreLoanAppDisclosuresResult>;
  skPreLoanAppDisclosuresRedirect?: Maybe<SkPreLoanAppDisclosuresRedirectResult>;
  submitDocuments?: Maybe<DocumentListModel>;
  submitLoanApplicationIndividualScheduledPayments?: Maybe<IndividualScheduledPaymentsModel>;
  tick?: Maybe<TickResult>;
}


export interface LoanApplicationMutationsAcceptDisclosuresArgs {
  model?: InputMaybe<ReviewDisclosuresViewModelInput>;
}


export interface LoanApplicationMutationsAcceptMarketingInvitationArgs {
  reservationCode?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationMutationsApplyDiscountCodeArgs {
  code?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationMutationsDeclineMarketingInvitationArgs {
  reservationCode?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationMutationsLogBankNotSupportedArgs {
  inputModel?: InputMaybe<BankInputModel>;
}


export interface LoanApplicationMutationsOutOfWalletSaveArgs {
  model?: InputMaybe<OutOfWalletSaveRequest>;
}


export interface LoanApplicationMutationsPersistAccountInputModelArgs {
  inputModel?: InputMaybe<AccountInputModel>;
}


export interface LoanApplicationMutationsPersistBankInputModelArgs {
  inputModel?: InputMaybe<BankInputModel>;
}


export interface LoanApplicationMutationsPersistBankVerificationLoginDetailsArgs {
  loginId?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationMutationsPersistBusinessLoanModelArgs {
  inputModel?: InputMaybe<BusinessLoanInputModel>;
}


export interface LoanApplicationMutationsPersistCommunicationConsentInputModelArgs {
  inputModel?: InputMaybe<CommunicationConsentInputModel>;
}


export interface LoanApplicationMutationsPersistIdentificationInputModelArgs {
  inputModel?: InputMaybe<IdentificationInputModel>;
}


export interface LoanApplicationMutationsPersistOowForTestLoanArgs {
  model?: InputMaybe<OutOfWalletTestingModelInput>;
}


export interface LoanApplicationMutationsPersistOowForTestLoanApplicationArgs {
  model?: InputMaybe<OutOfWalletTestingModelInput>;
}


export interface LoanApplicationMutationsPersistPaystubInputModelArgs {
  inputModel?: InputMaybe<PaystubInputModel>;
}


export interface LoanApplicationMutationsPersistPersonalInputModelArgs {
  inputModel?: InputMaybe<PersonalInputModel>;
}


export interface LoanApplicationMutationsPersistReservationInputModelArgs {
  inputModel?: InputMaybe<ReservationInputModel>;
}


export interface LoanApplicationMutationsPersistReviewInputModelArgs {
  inputModel?: InputMaybe<ReviewInputModel>;
}


export interface LoanApplicationMutationsPersistSelectTermsInputModelArgs {
  inputModel?: InputMaybe<SelectTermsInputModel>;
}


export interface LoanApplicationMutationsPersistVehicleInputsArgs {
  inputs?: InputMaybe<VehicleInputModelInput>;
}


export interface LoanApplicationMutationsPersistVehicleLienHolderInputsArgs {
  inputs?: InputMaybe<VehicleLienHolderInputModelInput>;
}


export interface LoanApplicationMutationsPreLoanAppDisclosuresArgs {
  model?: InputMaybe<PreLoanAppDisclosuresRequest>;
}


export interface LoanApplicationMutationsPreLoanAppDisclosuresRedirectArgs {
  model?: InputMaybe<PreLoanAppDisclosuresRedirectRequest>;
}


export interface LoanApplicationMutationsSaveBankInputModelArgs {
  inputModel?: InputMaybe<BankInputModel>;
}


export interface LoanApplicationMutationsSavePersonalInputModelArgs {
  inputModel?: InputMaybe<PersonalInputModel>;
}


export interface LoanApplicationMutationsSaveProductSelectionArgs {
  model?: InputMaybe<ProductSelectionSaveRequest>;
}


export interface LoanApplicationMutationsSubmitDocumentsArgs {
  model?: InputMaybe<DocumentListModelInput>;
}


export interface LoanApplicationMutationsSubmitLoanApplicationIndividualScheduledPaymentsArgs {
  model?: InputMaybe<IndividualScheduledPaymentsModelInput>;
}

export enum LoanApplicationOrigin {
  Cito = 'CITO',
  Curo = 'CURO',
  Web = 'WEB'
}

export interface LoanApplicationQueries {
  disclosures?: Maybe<ReviewDisclosuresViewModel>;
  getAccountViewModel?: Maybe<AccountViewModel>;
  getBankVerificationFailOptions?: Maybe<BankVerificationFailResult>;
  getBankVerificationViewModel?: Maybe<BankVerificationViewModel>;
  getBankViewModel?: Maybe<BankViewModel>;
  getBusinessLoanModel?: Maybe<BusinessLoanDisplayModel>;
  getCurrentApplicationStatus?: Maybe<LoanApplicationInfo>;
  getDeniedViewModel?: Maybe<DeniedViewModel>;
  getDocuments?: Maybe<DocumentListModel>;
  getIdentificationViewModel?: Maybe<IdentificationViewModel>;
  getIncomeVerificationMethods?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  getIncomeViewModel?: Maybe<IncomeViewModel>;
  getLoanApplicationIndividualScheduledPayments?: Maybe<IndividualScheduledPaymentsModel>;
  getLoanProtectionPlanViewModel?: Maybe<LoanProtectionPlanViewModel>;
  getMarketingInvitationModel?: Maybe<MarketingInvitationModel>;
  getOptionalPaymentAuthorizationViewModel?: Maybe<OptionalPaymentAuthorizationViewModel>;
  getPaystubViewModel?: Maybe<PaystubViewModel>;
  getPendingContent?: Maybe<PendingViewModel>;
  getPersonalViewModel?: Maybe<PersonalViewModel>;
  getReviewViewModel?: Maybe<ReviewViewModel>;
  getScoringOutageModel?: Maybe<OutageModel>;
  getSelectTermsViewModel?: Maybe<SelectTermsViewModel>;
  getVehicleByVin?: Maybe<VehicleViewModel>;
  getVehicleMakeView?: Maybe<VehicleViewModel>;
  getVehicleModelView?: Maybe<VehicleViewModel>;
  getVehicleValueView?: Maybe<VehicleViewModel>;
  getVehicleView?: Maybe<VehicleViewModel>;
  outOfWallet?: Maybe<OutOfWalletResult>;
  overrideOowForTest?: Maybe<OutOfWalletTestingModel>;
  process?: Maybe<ProcessResult>;
  productSelection?: Maybe<ProductSelectionModel>;
  progression?: Maybe<ProgressionResult>;
  validateEmail?: Maybe<EmailValidationModel>;
}


export interface LoanApplicationQueriesGetAccountViewModelArgs {
  cashCentralApprovalData?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationQueriesGetIncomeVerificationMethodsArgs {
  incomeVerificationType?: InputMaybe<Scalars['Int']>;
}


export interface LoanApplicationQueriesGetIncomeViewModelArgs {
  incomeTypeCode?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationQueriesGetVehicleByVinArgs {
  vin?: InputMaybe<Scalars['String']>;
}


export interface LoanApplicationQueriesGetVehicleMakeViewArgs {
  year?: InputMaybe<Scalars['Int']>;
}


export interface LoanApplicationQueriesGetVehicleModelViewArgs {
  make?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
}


export interface LoanApplicationQueriesGetVehicleValueViewArgs {
  make?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
}


export interface LoanApplicationQueriesProgressionArgs {
  currentSection?: InputMaybe<LoanApplicationSection>;
}


export interface LoanApplicationQueriesValidateEmailArgs {
  email?: InputMaybe<Scalars['String']>;
}

export enum LoanApplicationSection {
  Account = 'ACCOUNT',
  Banking = 'BANKING',
  BankVerification = 'BANK_VERIFICATION',
  Business = 'BUSINESS',
  Disclosures = 'DISCLOSURES',
  EmailVerification = 'EMAIL_VERIFICATION',
  Id = 'ID',
  Income = 'INCOME',
  Personal = 'PERSONAL',
  PhoneVerification = 'PHONE_VERIFICATION',
  Spouse = 'SPOUSE',
  Unknown = 'UNKNOWN',
  Vehicle = 'VEHICLE'
}

export interface LoanApplicationSectionStringKeyValuePairGraphType {
  key: LoanApplicationSection;
  value: Scalars['String'];
}

export enum LoanPaymentPlanType {
  Canada = 'CANADA',
  None = 'NONE',
  Washington = 'WASHINGTON'
}

export interface LoanProtectionPlanViewModel {
  isInsuranceOptIn: Scalars['Boolean'];
  isOpenEnd: Scalars['Boolean'];
}

export interface LoanTerm {
  length: Scalars['Int'];
  termType: TermType;
}

export interface LoanTermInput {
  length?: InputMaybe<Scalars['Int']>;
  termType?: InputMaybe<TermType>;
}

export enum LoanType {
  None = 'NONE',
  Payday = 'PAYDAY',
  Signature = 'SIGNATURE',
  Title = 'TITLE'
}

export enum MaritalStatus {
  /** Legally Separated */
  LegallySeparated = 'LEGALLY_SEPARATED',
  /** Married */
  Married = 'MARRIED',
  None = 'NONE',
  /** Unmarried */
  Unmarried = 'UNMARRIED'
}

export interface MarketingInvitationModel {
  acceptUrl?: Maybe<Scalars['String']>;
  cashCentralExistingBalance?: Maybe<Scalars['Decimal']>;
  declineUrl?: Maybe<Scalars['String']>;
  displayDecline: Scalars['Boolean'];
  displayReservationCode: Scalars['Boolean'];
  expirationDate: Scalars['DateTime'];
  loanProductDescription?: Maybe<Scalars['String']>;
  preApprovedLoanAmount: Scalars['Decimal'];
  ratesAndTermsUrl?: Maybe<Scalars['String']>;
  reservationCode?: Maybe<Scalars['String']>;
}

export interface MarketingInvitationModelInput {
  acceptUrl?: InputMaybe<Scalars['String']>;
  cashCentralExistingBalance?: InputMaybe<Scalars['Decimal']>;
  declineUrl?: InputMaybe<Scalars['String']>;
  displayDecline?: InputMaybe<Scalars['Boolean']>;
  displayReservationCode?: InputMaybe<Scalars['Boolean']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  loanProductDescription?: InputMaybe<Scalars['String']>;
  preApprovedLoanAmount?: InputMaybe<Scalars['Decimal']>;
  ratesAndTermsUrl?: InputMaybe<Scalars['String']>;
  reservationCode?: InputMaybe<Scalars['String']>;
}

export interface MatchedCustomerModel {
  customerKey: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  homeAddress?: Maybe<AddressModel>;
  homePhone?: Maybe<Scalars['String']>;
  isConfirmed: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  numMatches: Scalars['Int'];
  socialSecurityNumber?: Maybe<Scalars['String']>;
  visitorKey: Scalars['Int'];
}

export interface NameModel {
  firstInitial?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  initials?: Maybe<Scalars['String']>;
  lastInitial?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleInitial?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
}

export interface NameModelInput {
  firstInitial?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  initials?: InputMaybe<Scalars['String']>;
  lastInitial?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleInitial?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
}

export interface NewLoanApplicationResult {
  hasLoanApplication: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
}

export enum NextMonthlyPayDateMethod {
  Exact = 'EXACT',
  None = 'NONE',
  NthBusinessDay = 'NTH_BUSINESS_DAY',
  NthFromLastBusinessDay = 'NTH_FROM_LAST_BUSINESS_DAY',
  NthWeekday = 'NTH_WEEKDAY'
}

export enum NoSignatureAction {
  /** None */
  None = 'NONE',
  /** Signature Not Required */
  NotRequiredDoNotRequestSigStored = 'NOT_REQUIRED_DO_NOT_REQUEST_SIG_STORED',
  /** Require more information with docs */
  NotRequiredMoreInfoStored = 'NOT_REQUIRED_MORE_INFO_STORED',
  /** Continue, do not store in Docuware */
  NotRequiredNotStored = 'NOT_REQUIRED_NOT_STORED',
  /** Required, do not display on the web */
  RequiredNoWebDisplayStored = 'REQUIRED_NO_WEB_DISPLAY_STORED',
  /** Document Required */
  RequiredStored = 'REQUIRED_STORED'
}

export enum NodeType {
  BulletListItem = 'BULLET_LIST_ITEM',
  Button = 'BUTTON',
  Card = 'CARD',
  CheckBox = 'CHECK_BOX',
  Heading_1 = 'HEADING_1',
  Heading_2 = 'HEADING_2',
  Heading_3 = 'HEADING_3',
  Heading_4 = 'HEADING_4',
  Heading_5 = 'HEADING_5',
  Image = 'IMAGE',
  None = 'NONE',
  Page = 'PAGE',
  Paragraph = 'PARAGRAPH',
  RadioButton = 'RADIO_BUTTON',
  RadioButtonGroup = 'RADIO_BUTTON_GROUP',
  Text = 'TEXT',
  TextLink = 'TEXT_LINK',
  TextValue = 'TEXT_VALUE',
  ToggleSwitch = 'TOGGLE_SWITCH',
  View = 'VIEW'
}

export interface OptionalPaymentAuthorizationViewModel {
  paperlessBillingEnabled: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
  storeLocationUrl?: Maybe<Scalars['String']>;
}

export enum OtherEarningsType {
  /** Bonus */
  Bonus = 'BONUS',
  /** None */
  None = 'NONE',
  /** Other */
  Other = 'OTHER',
  /** Vacation */
  Vacation = 'VACATION'
}

export interface OutOfWalletAnswerModel {
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface OutOfWalletAnswerModelInput {
  text?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export enum OutOfWalletForceResultType {
  /** Fail */
  Fail = 'FAIL',
  /** ID Needed */
  IdNeeded = 'ID_NEEDED',
  /** Lockout 20002 */
  Lockout_20002 = 'LOCKOUT_20002',
  /** Not Taken */
  NotTaken = 'NOT_TAKEN',
  /** No hit 20006 */
  NoHit_20006 = 'NO_HIT_20006',
  /** Pass */
  Pass = 'PASS',
  /** System Error */
  SystemError = 'SYSTEM_ERROR',
  /** Thin File 20003 */
  ThinFile_20003 = 'THIN_FILE_20003'
}

export interface OutOfWalletModelInput {
  questions?: InputMaybe<Array<InputMaybe<OutOfWalletQuestionModelInput>>>;
  testResult?: InputMaybe<OutOfWalletForceResultType>;
}

export interface OutOfWalletQuestionModel {
  actualTime: Scalars['Int'];
  answerId: Scalars['Int'];
  possibleAnswers?: Maybe<Array<Maybe<OutOfWalletAnswerModel>>>;
  questionId: Scalars['Long'];
  text?: Maybe<Scalars['String']>;
  timePermitted: Scalars['Int'];
  validationMessage?: Maybe<Scalars['String']>;
}

export interface OutOfWalletQuestionModelInput {
  actualTime?: InputMaybe<Scalars['Int']>;
  answerId?: InputMaybe<Scalars['Int']>;
  possibleAnswers?: InputMaybe<Array<InputMaybe<OutOfWalletAnswerModelInput>>>;
  questionId?: InputMaybe<Scalars['Long']>;
  text?: InputMaybe<Scalars['String']>;
  timePermitted?: InputMaybe<Scalars['Int']>;
  validationMessage?: InputMaybe<Scalars['String']>;
}

export interface OutOfWalletResult {
  questions?: Maybe<Array<Maybe<OutOfWalletQuestionModel>>>;
  redirectUrl?: Maybe<Scalars['String']>;
}

export interface OutOfWalletSaveRequest {
  outOfWalletModel?: InputMaybe<OutOfWalletModelInput>;
}

export interface OutOfWalletSaveResult {
  questions?: Maybe<Array<Maybe<OutOfWalletQuestionModel>>>;
  redirectUrl?: Maybe<Scalars['String']>;
}

export enum OutOfWalletTestType {
  ForceTestResult = 'FORCE_TEST_RESULT',
  None = 'NONE',
  TestAccount = 'TEST_ACCOUNT'
}

export interface OutOfWalletTestingModel {
  bypassOOW: Scalars['Boolean'];
  currentTestType: OutOfWalletTestType;
  forceResultType?: Maybe<OutOfWalletForceResultType>;
  forceResultsList?: Maybe<Array<Maybe<OutOfWalletAnswerModel>>>;
  loanKey: Scalars['Int'];
  redirectUrl?: Maybe<Scalars['String']>;
  testAccountId?: Maybe<Scalars['Int']>;
  testAccountsList?: Maybe<Array<Maybe<OutOfWalletAnswerModel>>>;
}

export interface OutOfWalletTestingModelInput {
  bypassOOW?: InputMaybe<Scalars['Boolean']>;
  currentTestType?: InputMaybe<OutOfWalletTestType>;
  forceResultType?: InputMaybe<OutOfWalletForceResultType>;
  forceResultsList?: InputMaybe<Array<InputMaybe<OutOfWalletAnswerModelInput>>>;
  loanKey?: InputMaybe<Scalars['Int']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  testAccountId?: InputMaybe<Scalars['Int']>;
  testAccountsList?: InputMaybe<Array<InputMaybe<OutOfWalletAnswerModelInput>>>;
}

export interface OutageModel {
  nearStore: Scalars['Boolean'];
}

export enum PayCycle {
  /** BiWeekly */
  BiWeekly = 'BI_WEEKLY',
  /** 4 Weekly */
  FourWeekly = 'FOUR_WEEKLY',
  /** Irregular */
  Irregular = 'IRREGULAR',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** None */
  None = 'NONE',
  /** 3 Weekly */
  ThreeWeekly = 'THREE_WEEKLY',
  /** Twice Month */
  TwiceMonthly = 'TWICE_MONTHLY',
  /** Weekly */
  Weekly = 'WEEKLY'
}

export enum PayCycleMonthInterval {
  /** Business Day of month */
  BusinessDay = 'BUSINESS_DAY',
  /** Day of month */
  DayOfMonth = 'DAY_OF_MONTH',
  /** 1st week of month */
  FirstWeek = 'FIRST_WEEK',
  /** 4th week of month */
  FourthWeek = 'FOURTH_WEEK',
  /** Last week of month */
  LastWeek = 'LAST_WEEK',
  /** None */
  None = 'NONE',
  /** 2nd week of month */
  SecondWeek = 'SECOND_WEEK',
  /** 3rd week of month */
  ThirdWeek = 'THIRD_WEEK'
}

export enum PayType {
  Commission = 'COMMISSION',
  Hourly = 'HOURLY',
  Salary = 'SALARY'
}

export interface PaystubInputModel {
  checkDate?: InputMaybe<DateModelInput>;
  checkNumber?: InputMaybe<Scalars['String']>;
  fICA?: InputMaybe<Scalars['Decimal']>;
  federalTax?: InputMaybe<Scalars['Decimal']>;
  hireDate?: InputMaybe<DateModelInput>;
  income?: InputMaybe<IncomeModelInput>;
  incomeAfterTaxes?: InputMaybe<Scalars['Decimal']>;
  initials?: InputMaybe<Scalars['String']>;
  medicare?: InputMaybe<Scalars['Decimal']>;
  otherEarningsAmount?: InputMaybe<Scalars['Decimal']>;
  otherEarningsType?: InputMaybe<OtherEarningsType>;
  overtimeHourlyRate?: InputMaybe<Scalars['Decimal']>;
  overtimeHours?: InputMaybe<Scalars['Decimal']>;
  payPeriodEnd?: InputMaybe<DateModelInput>;
  payType?: InputMaybe<PayType>;
  regularHourlyRate?: InputMaybe<Scalars['Decimal']>;
  regularHours?: InputMaybe<Scalars['Decimal']>;
  stateTax?: InputMaybe<Scalars['Decimal']>;
  taxableWages?: InputMaybe<Scalars['Decimal']>;
  yearToDate?: InputMaybe<Scalars['Decimal']>;
}

export interface PaystubViewModel {
  checkDate?: Maybe<DateModel>;
  firstName?: Maybe<Scalars['String']>;
  hireDate?: Maybe<DateModel>;
  income?: Maybe<IncomeModel>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  payPeriodEnd?: Maybe<DateModel>;
  redirectUrl?: Maybe<Scalars['String']>;
}

export interface PendingViewModel {
  content?: Maybe<Array<Maybe<DynamicContent>>>;
  redirect?: Maybe<Scalars['String']>;
}

export interface PeriodicPayModel {
  gross?: Maybe<Scalars['Decimal']>;
  incomeVerificationMethodGross?: Maybe<Scalars['Int']>;
  incomeVerificationMethodNet?: Maybe<Scalars['Int']>;
  incomeVerificationTypeGross?: Maybe<Scalars['Int']>;
  incomeVerificationTypeNet?: Maybe<Scalars['Int']>;
  net?: Maybe<Scalars['Decimal']>;
  payday?: Maybe<Scalars['DateTime']>;
}

export interface PeriodicPayModelInput {
  gross?: InputMaybe<Scalars['Decimal']>;
  incomeVerificationMethodGross?: InputMaybe<Scalars['Int']>;
  incomeVerificationMethodNet?: InputMaybe<Scalars['Int']>;
  incomeVerificationTypeGross?: InputMaybe<Scalars['Int']>;
  incomeVerificationTypeNet?: InputMaybe<Scalars['Int']>;
  net?: InputMaybe<Scalars['Decimal']>;
  payday?: InputMaybe<Scalars['DateTime']>;
}

export interface PersonalInputModel {
  address?: InputMaybe<Scalars['String']>;
  birthDay?: InputMaybe<Scalars['Int']>;
  birthMonth?: InputMaybe<Scalars['Int']>;
  birthYear?: InputMaybe<Scalars['Int']>;
  city?: InputMaybe<Scalars['String']>;
  communicationConsentOperational?: InputMaybe<Scalars['Boolean']>;
  communicationConsentPromotional?: InputMaybe<Scalars['Boolean']>;
  continueWithMatchingCustomer?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  homePhone?: InputMaybe<Scalars['String']>;
  housing?: InputMaybe<Housing>;
  isMilitary?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  residenceSinceMonth?: InputMaybe<Scalars['Int']>;
  residenceSinceYear?: InputMaybe<Scalars['Int']>;
  socialSecurityNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  unitNumber?: InputMaybe<Scalars['String']>;
  unitType?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
}

export interface PersonalViewModel {
  address?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  canEditBirthDate: Scalars['Boolean'];
  canEditPersonName: Scalars['Boolean'];
  canEditSocialSecurityNumber: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  curoDodDualAuth?: Maybe<CuroDodDualAuthModel>;
  curoMilitaryScoreErrorCount: Scalars['Int'];
  firstName?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  housing?: Maybe<Housing>;
  inLoanAppReview: Scalars['Boolean'];
  isMilitary?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  marketingInvitation?: Maybe<MarketingInvitationModel>;
  matchedCustomer?: Maybe<MatchedCustomerModel>;
  middleName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  origin: LoanApplicationOrigin;
  redirectUrl?: Maybe<Scalars['String']>;
  requestCommunicationConsentOperational: Scalars['Boolean'];
  requestCommunicationConsentPromotional: Scalars['Boolean'];
  residenceSince?: Maybe<Scalars['DateTime']>;
  socialSecurityNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  unitType?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
}

export interface PreLoanAppDisclosuresRedirectRequest {
  province?: InputMaybe<Scalars['String']>;
}

export interface PreLoanAppDisclosuresRedirectResult {
  redirectUrl?: Maybe<Scalars['String']>;
}

export interface PreLoanAppDisclosuresRequest {
  province?: InputMaybe<Scalars['String']>;
  requestedAmount?: InputMaybe<Scalars['Decimal']>;
}

export interface PreLoanAppDisclosuresResult {
  costComparisonFileName?: Maybe<Scalars['String']>;
  noProvinceUrl?: Maybe<Scalars['String']>;
  oNCostComparisonFileName?: Maybe<Scalars['String']>;
  productType: ProductType;
  province: State;
  redirectUrl?: Maybe<Scalars['String']>;
}

export enum PrescreenOfferDetailReason {
  HasExpired = 'HAS_EXPIRED',
  IdentificationCodeDoesNotMatch = 'IDENTIFICATION_CODE_DOES_NOT_MATCH',
  Invalid = 'INVALID',
  None = 'NONE',
  OfferRedeemed = 'OFFER_REDEEMED',
  StoreOnly = 'STORE_ONLY'
}

export interface ProcessResult {
  redirectUrl?: Maybe<Scalars['String']>;
}

export interface ProductInfoModel {
  annualPercentageRate?: Maybe<Scalars['Decimal']>;
  disclaimer?: Maybe<Scalars['String']>;
  howLong?: Maybe<Scalars['String']>;
  howMuch?: Maybe<Scalars['String']>;
  insuranceFeeAmount?: Maybe<Scalars['Decimal']>;
  loanFeeAmt?: Maybe<Scalars['Decimal']>;
  loanProductConfigKey: Scalars['Int'];
  lppInsuranceCompany?: Maybe<Scalars['String']>;
  maximumLoanAmount: Scalars['Decimal'];
  maximumLoanLengthDays: Scalars['Short'];
  order?: Maybe<Scalars['Int']>;
  paymentAmount?: Maybe<Scalars['Decimal']>;
  productHeader?: Maybe<Scalars['String']>;
  productType: ProductType;
  selectedLoanTerm?: Maybe<LoanTerm>;
}

export interface ProductSelectionModel {
  disclaimers?: Maybe<Array<Maybe<Scalars['String']>>>;
  exitPromptEnabled: Scalars['Boolean'];
  isInStore: Scalars['Boolean'];
  isRapidCash: Scalars['Boolean'];
  loanProductConfigKey: Scalars['Int'];
  products?: Maybe<Array<Maybe<ProductInfoModel>>>;
  selectProductBeforeApp: Scalars['Boolean'];
}

export interface ProductSelectionSaveRequest {
  isInStore?: InputMaybe<Scalars['Boolean']>;
  loanProductConfigKey?: InputMaybe<Scalars['Int']>;
}

export interface ProductSelectionSaveResult {
  errors?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  redirectUrl?: Maybe<Scalars['String']>;
}

export enum ProductType {
  /** Cashed Check */
  CashedCheck = 'CASHED_CHECK',
  /** Currency Exchange */
  CurrencyExchange = 'CURRENCY_EXCHANGE',
  /** Gold */
  Gold = 'GOLD',
  /** Installment */
  Installment = 'INSTALLMENT',
  None = 'NONE',
  /** Open End */
  OpenEnd = 'OPEN_END',
  /** OptPlus */
  OptPlus = 'OPT_PLUS',
  /** Single Pay */
  SinglePay = 'SINGLE_PAY'
}

export interface ProgressionResult {
  completePercent: Scalars['Int'];
  enabledSections?: Maybe<Array<Maybe<LoanApplicationSection>>>;
  followingRoute?: Maybe<Scalars['String']>;
  followingSection: LoanApplicationSection;
  numberComplete: Scalars['Int'];
  precedingRoute?: Maybe<Scalars['String']>;
  precedingSection: LoanApplicationSection;
}

export interface ReservationInputModel {
  identificationCode?: InputMaybe<Scalars['String']>;
  reservationCode?: InputMaybe<Scalars['String']>;
  reservationCodeNumber?: InputMaybe<Scalars['Long']>;
}

export interface ReservationViewModel {
  reason: PrescreenOfferDetailReason;
}

export interface ReviewDisclosuresViewModel {
  completingLoanByPhone: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  disclosures?: Maybe<Array<Maybe<DisclosureModel>>>;
  discountCode?: Maybe<DiscountCodeViewModel>;
  inLoanAppReview: Scalars['Boolean'];
  isPendingOrForceApprovedLPP: Scalars['Boolean'];
  isSpanishDocsEnabled: Scalars['Boolean'];
  language: LanguageType;
  marketingInvitation?: Maybe<MarketingInvitationModel>;
  redirectUrl?: Maybe<Scalars['String']>;
  state: State;
  stateName?: Maybe<Scalars['String']>;
}

export interface ReviewDisclosuresViewModelInput {
  completingLoanByPhone?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  disclosures?: InputMaybe<Array<InputMaybe<DisclosureModelInput>>>;
  discountCode?: InputMaybe<DiscountCodeViewModelInput>;
  inLoanAppReview?: InputMaybe<Scalars['Boolean']>;
  isPendingOrForceApprovedLPP?: InputMaybe<Scalars['Boolean']>;
  isSpanishDocsEnabled?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<LanguageType>;
  marketingInvitation?: InputMaybe<MarketingInvitationModelInput>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<State>;
  stateName?: InputMaybe<Scalars['String']>;
}

export interface ReviewInputModel {
  accountActiveAndOpen?: InputMaybe<Scalars['Boolean']>;
  isMilitary?: InputMaybe<Scalars['Boolean']>;
}

export interface ReviewViewModel {
  accountNumberDisplay?: Maybe<Scalars['String']>;
  address?: Maybe<AddressModel>;
  bankName?: Maybe<Scalars['String']>;
  bankRoutingNumber?: Maybe<Scalars['String']>;
  businessAddress?: Maybe<AddressModel>;
  businessName?: Maybe<Scalars['String']>;
  cardExpiry: Scalars['DateTime'];
  cardNumberDisplay?: Maybe<Scalars['String']>;
  cellPhone?: Maybe<Scalars['String']>;
  confirmNoCard?: Maybe<ConfirmNoCardModel>;
  enabledAppSections?: Maybe<Array<Maybe<LoanApplicationSection>>>;
  firstName?: Maybe<Scalars['String']>;
  homePhone?: Maybe<Scalars['String']>;
  identificationCountry?: Maybe<Scalars['String']>;
  identificationExpiry?: Maybe<Scalars['DateTime']>;
  identificationExpiryDay?: Maybe<Scalars['Int']>;
  identificationExpiryMonth?: Maybe<Scalars['Int']>;
  identificationExpiryYear?: Maybe<Scalars['Int']>;
  identificationNumber?: Maybe<Scalars['String']>;
  identificationState?: Maybe<Scalars['String']>;
  identificationTypeKey?: Maybe<Scalars['Int']>;
  identificationTypeDescription?: Maybe<Scalars['String']>;
  incomes?: Maybe<Array<Maybe<IncomeModel>>>;
  isBusinessLoan: Scalars['Boolean'];
  isIdentificationNonExpiry: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  maritalStatus: MaritalStatus;
  marketingInvitation?: Maybe<MarketingInvitationModel>;
  origin: LoanApplicationOrigin;
  redirectUrl?: Maybe<Scalars['String']>;
  showId?: Maybe<Scalars['Boolean']>;
  spouseAddress?: Maybe<AddressModel>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  urls?: Maybe<Array<Maybe<LoanApplicationSectionStringKeyValuePairGraphType>>>;
  vehicleIdentificationNumber?: Maybe<Scalars['String']>;
  vehicleMake?: Maybe<Scalars['String']>;
  vehicleModel?: Maybe<Scalars['String']>;
  vehicleYear: Scalars['Short'];
}

export interface ScheduledPaymentModel {
  amount: Scalars['Decimal'];
  date: Scalars['DateTime'];
  key: Scalars['Int'];
  scheduled: Scalars['Boolean'];
}

export interface ScheduledPaymentModelInput {
  amount?: InputMaybe<Scalars['Decimal']>;
  date?: InputMaybe<Scalars['DateTime']>;
  key?: InputMaybe<Scalars['Int']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
}

export interface ScoreResults {
  creditAgenciesThatDenied?: Maybe<Array<Maybe<CreditAgency>>>;
  creditAgencyList?: Maybe<Array<Maybe<CreditAgency>>>;
  denialReasonTalkOffs?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  denialReasonsSRC?: Maybe<Array<Maybe<Int32StringKeyValuePairGraphType>>>;
  denialReasonsState?: Maybe<Array<Maybe<Int32StringKeyValuePairGraphType>>>;
  denialReasonsVendor?: Maybe<Array<Maybe<Int32StringKeyValuePairGraphType>>>;
  hadCreditFreeze: Scalars['Boolean'];
  hadCreditLock: Scalars['Boolean'];
  isApproved: Scalars['Boolean'];
  isDeniedSRC: Scalars['Boolean'];
  isDeniedState: Scalars['Boolean'];
  isInStateWaitingPeriod: Scalars['Boolean'];
  loanType?: Maybe<Scalars['String']>;
  maxOverrideTierAmtForScoredProduct: Scalars['Decimal'];
  pointsNeededForApproval: Scalars['Decimal'];
  productType?: Maybe<Scalars['String']>;
  scoreApprovalAmt: Scalars['Decimal'];
  scoreDescriptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  scorePoints: Scalars['Decimal'];
  scoreSummaryKey: Scalars['Int'];
  scoreValues?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  stateDBMaxLoanDays: Scalars['Int'];
}

export interface SelectListGroup {
  disabled: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
}

export interface SelectListGroupInput {
  disabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
}

export interface SelectListItem {
  disabled: Scalars['Boolean'];
  group?: Maybe<SelectListGroup>;
  selected: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
}

export interface SelectListItemInput {
  disabled?: InputMaybe<Scalars['Boolean']>;
  group?: InputMaybe<SelectListGroupInput>;
  selected?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
}

export interface SelectTermsInputModel {
  emailStatements?: InputMaybe<Scalars['Boolean']>;
  selectedLoanAmount?: InputMaybe<Scalars['Decimal']>;
  selectedLoanTerm?: InputMaybe<LoanTermInput>;
}

export interface SelectTermsViewModel {
  canReturnToProductSelection?: Maybe<Scalars['Boolean']>;
  cashCentralExistingBalance?: Maybe<Scalars['Decimal']>;
  emailStatements: Scalars['Boolean'];
  exitPromptEnabled: Scalars['Boolean'];
  installmentLoanOptions?: Maybe<Array<Maybe<InstallmentLoanOptionModel>>>;
  isInsuredProduct: Scalars['Boolean'];
  isOptedIntoInsurance: Scalars['Boolean'];
  loanHistoryDaysToLookBack: Scalars['Short'];
  maximumLoanAmount: Scalars['Decimal'];
  minimumLoanAmount: Scalars['Decimal'];
  payCycle: PayCycle;
  paymentPlanType: LoanPaymentPlanType;
  productDescription?: Maybe<Scalars['String']>;
  productType: ProductType;
  redirect?: Maybe<Scalars['String']>;
  requireUserInputAmount: Scalars['Boolean'];
  selectedLoanAmount: Scalars['Decimal'];
  validLoanAmounts?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  validLoanTerms?: Maybe<Array<Maybe<LoanTerm>>>;
}

export interface SkPreLoanAppDisclosuresRedirectResult {
  redirectUrl?: Maybe<Scalars['String']>;
}

export interface SkPreLoanAppDisclosuresResult {
  disclosureDownloadUrl?: Maybe<Scalars['String']>;
  redirectUrl?: Maybe<Scalars['String']>;
}

export enum State {
  Alabama = 'ALABAMA',
  Alaska = 'ALASKA',
  Alberta = 'ALBERTA',
  Arizona = 'ARIZONA',
  Arkansas = 'ARKANSAS',
  /** British Columbia */
  BritishColumbia = 'BRITISH_COLUMBIA',
  California = 'CALIFORNIA',
  Colorado = 'COLORADO',
  Connecticut = 'CONNECTICUT',
  Delaware = 'DELAWARE',
  /** District of Columbia */
  DistrictOfColumbia = 'DISTRICT_OF_COLUMBIA',
  Florida = 'FLORIDA',
  Georgia = 'GEORGIA',
  Hawaii = 'HAWAII',
  Idaho = 'IDAHO',
  Illinois = 'ILLINOIS',
  Indiana = 'INDIANA',
  Iowa = 'IOWA',
  Kansas = 'KANSAS',
  Kentucky = 'KENTUCKY',
  Louisiana = 'LOUISIANA',
  Maine = 'MAINE',
  Manitoba = 'MANITOBA',
  Maryland = 'MARYLAND',
  Massachusetts = 'MASSACHUSETTS',
  Michigan = 'MICHIGAN',
  Minnesota = 'MINNESOTA',
  Mississippi = 'MISSISSIPPI',
  Missouri = 'MISSOURI',
  Montana = 'MONTANA',
  Nebraska = 'NEBRASKA',
  Nevada = 'NEVADA',
  /** Newfoundland And Labrador */
  NewfoundlandAndLabrador = 'NEWFOUNDLAND_AND_LABRADOR',
  /** New Brunswick */
  NewBrunswick = 'NEW_BRUNSWICK',
  /** New Hampshire */
  NewHampshire = 'NEW_HAMPSHIRE',
  /** New Jersey */
  NewJersey = 'NEW_JERSEY',
  /** New Mexico */
  NewMexico = 'NEW_MEXICO',
  /** New York */
  NewYork = 'NEW_YORK',
  /** Northwest Territories */
  NorthwestTerritories = 'NORTHWEST_TERRITORIES',
  /** North Carolina */
  NorthCarolina = 'NORTH_CAROLINA',
  /** North Dakota */
  NorthDakota = 'NORTH_DAKOTA',
  /** Nova Scotia */
  NovaScotia = 'NOVA_SCOTIA',
  Nunavut = 'NUNAVUT',
  Ohio = 'OHIO',
  Oklahoma = 'OKLAHOMA',
  Ontario = 'ONTARIO',
  Oregon = 'OREGON',
  Pennsylvania = 'PENNSYLVANIA',
  /** Prince Edward Island */
  PrinceEdwardIsland = 'PRINCE_EDWARD_ISLAND',
  Quebec = 'QUEBEC',
  /** Rhode Island */
  RhodeIsland = 'RHODE_ISLAND',
  Saskatchewan = 'SASKATCHEWAN',
  /** South Carolina */
  SouthCarolina = 'SOUTH_CAROLINA',
  /** South Dakota */
  SouthDakota = 'SOUTH_DAKOTA',
  Tennessee = 'TENNESSEE',
  Texas = 'TEXAS',
  Unknown = 'UNKNOWN',
  Utah = 'UTAH',
  Vermont = 'VERMONT',
  Virginia = 'VIRGINIA',
  Washington = 'WASHINGTON',
  /** West Virginia */
  WestVirginia = 'WEST_VIRGINIA',
  Wisconsin = 'WISCONSIN',
  Wyoming = 'WYOMING',
  Yukon = 'YUKON'
}

export interface StringBooleanKeyValuePairGraphType {
  key: Scalars['String'];
  value: Scalars['Boolean'];
}

export interface StringBooleanKeyValuePairInputGraphType {
  key: Scalars['String'];
  value: Scalars['Boolean'];
}

export interface StringInt32KeyValuePairGraphType {
  key: Scalars['String'];
  value: Scalars['Int'];
}

export interface StringStringKeyValuePairGraphType {
  key: Scalars['String'];
  value: Scalars['String'];
}

export enum TermType {
  Day = 'DAY',
  Month = 'MONTH',
  None = 'NONE',
  Payment = 'PAYMENT'
}

export enum TextDecorationLine {
  None = 'NONE',
  Underline = 'UNDERLINE'
}

export interface TextStyle {
  color?: Maybe<Scalars['String']>;
  fontStyle: FontStyle;
  fontWeight: FontWeight;
  marginBottom?: Maybe<Unit>;
  marginLeft?: Maybe<Unit>;
  marginRight?: Maybe<Unit>;
  marginTop?: Maybe<Unit>;
  textDecorationLine: TextDecorationLine;
}

export interface TickResult {
  processingCountExceeded: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
  scoringState?: Maybe<Scalars['String']>;
}

export enum TwiceMonthlyPayday {
  /** 15th and last day of the month */
  FifteenthAndLast = 'FIFTEENTH_AND_LAST',
  /** 5th and 20th */
  FifthAndTwentieth = 'FIFTH_AND_TWENTIETH',
  /** 1st and 15th */
  FirstAndFifteenth = 'FIRST_AND_FIFTEENTH',
  None = 'NONE',
  /** 7th and 22nd */
  SeventhAndTwentySecond = 'SEVENTH_AND_TWENTY_SECOND',
  /** 10th and 25th */
  TenthAndTwentyFifth = 'TENTH_AND_TWENTY_FIFTH'
}

export interface Unit {
  type?: Maybe<Scalars['String']>;
  value: Scalars['Int'];
}

export enum VehicleCondition {
  Average = 'AVERAGE',
  Excellent = 'EXCELLENT',
  None = 'NONE',
  Poor = 'POOR'
}

export interface VehicleInputModel {
  eyeColor?: Maybe<Scalars['String']>;
  fuelType?: Maybe<FuelType>;
  gender?: Maybe<Scalars['String']>;
  hairColor?: Maybe<Scalars['String']>;
  hasLien?: Maybe<Scalars['Boolean']>;
  heightFeet?: Maybe<Scalars['Byte']>;
  heightInches?: Maybe<Scalars['Byte']>;
  insuranceCompany?: Maybe<Scalars['String']>;
  insuranceCompanyPhone?: Maybe<Scalars['String']>;
  isLeasedVehicle?: Maybe<Scalars['Boolean']>;
  legalStatus?: Maybe<VehicleLegalStatus>;
  legalStatusFirstname?: Maybe<Scalars['String']>;
  legalStatusLastname?: Maybe<Scalars['String']>;
  legalStatusMiddlename?: Maybe<Scalars['String']>;
  lienAmount?: Maybe<Scalars['Decimal']>;
  lienHolder?: Maybe<Scalars['Int']>;
  lienHolderCustomName?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  makeOther?: Maybe<Scalars['String']>;
  mileage?: Maybe<Scalars['Int']>;
  model?: Maybe<Scalars['String']>;
  modelOther?: Maybe<Scalars['String']>;
  odometerCode?: Maybe<VehicleOdometerCode>;
  plate?: Maybe<Scalars['String']>;
  race?: Maybe<Scalars['String']>;
  regDateDay?: Maybe<Scalars['Int']>;
  regDateMonth?: Maybe<Scalars['Int']>;
  regDateYear?: Maybe<Scalars['Int']>;
  regExpiryDay?: Maybe<Scalars['Int']>;
  regExpiryMonth?: Maybe<Scalars['Int']>;
  regExpiryYear?: Maybe<Scalars['Int']>;
  registrationState?: Maybe<Scalars['String']>;
  retailValue?: Maybe<Scalars['Decimal']>;
  stateCustomerID?: Maybe<Scalars['String']>;
  sticker?: Maybe<Scalars['String']>;
  titleNumber?: Maybe<Scalars['String']>;
  vehicleCondition?: Maybe<VehicleCondition>;
  vehicleType?: Maybe<VehicleType>;
  vin?: Maybe<Scalars['String']>;
  wholesaleValue?: Maybe<Scalars['Decimal']>;
  year?: Maybe<Scalars['Short']>;
}

export interface VehicleInputModelInput {
  eyeColor?: InputMaybe<Scalars['String']>;
  fuelType?: InputMaybe<FuelType>;
  gender?: InputMaybe<Scalars['String']>;
  hairColor?: InputMaybe<Scalars['String']>;
  hasLien?: InputMaybe<Scalars['Boolean']>;
  heightFeet?: InputMaybe<Scalars['Byte']>;
  heightInches?: InputMaybe<Scalars['Byte']>;
  insuranceCompany?: InputMaybe<Scalars['String']>;
  insuranceCompanyPhone?: InputMaybe<Scalars['String']>;
  isLeasedVehicle?: InputMaybe<Scalars['Boolean']>;
  legalStatus?: InputMaybe<VehicleLegalStatus>;
  legalStatusFirstname?: InputMaybe<Scalars['String']>;
  legalStatusLastname?: InputMaybe<Scalars['String']>;
  legalStatusMiddlename?: InputMaybe<Scalars['String']>;
  lienAmount?: InputMaybe<Scalars['Decimal']>;
  lienHolder?: InputMaybe<Scalars['Int']>;
  lienHolderCustomName?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  makeOther?: InputMaybe<Scalars['String']>;
  mileage?: InputMaybe<Scalars['Int']>;
  model?: InputMaybe<Scalars['String']>;
  modelOther?: InputMaybe<Scalars['String']>;
  odometerCode?: InputMaybe<VehicleOdometerCode>;
  plate?: InputMaybe<Scalars['String']>;
  race?: InputMaybe<Scalars['String']>;
  regDateDay?: InputMaybe<Scalars['Int']>;
  regDateMonth?: InputMaybe<Scalars['Int']>;
  regDateYear?: InputMaybe<Scalars['Int']>;
  regExpiryDay?: InputMaybe<Scalars['Int']>;
  regExpiryMonth?: InputMaybe<Scalars['Int']>;
  regExpiryYear?: InputMaybe<Scalars['Int']>;
  registrationState?: InputMaybe<Scalars['String']>;
  retailValue?: InputMaybe<Scalars['Decimal']>;
  stateCustomerID?: InputMaybe<Scalars['String']>;
  sticker?: InputMaybe<Scalars['String']>;
  titleNumber?: InputMaybe<Scalars['String']>;
  vehicleCondition?: InputMaybe<VehicleCondition>;
  vehicleType?: InputMaybe<VehicleType>;
  vin?: InputMaybe<Scalars['String']>;
  wholesaleValue?: InputMaybe<Scalars['Decimal']>;
  year?: InputMaybe<Scalars['Short']>;
}

export enum VehicleLegalStatus {
  And = 'AND',
  AndOr = 'AND_OR',
  Na = 'NA',
  None = 'NONE',
  Or = 'OR'
}

export interface VehicleLienHolderInputModel {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  redirect?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
}

export interface VehicleLienHolderInputModelInput {
  address?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  redirect?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
}

export enum VehicleOdometerCode {
  A = 'A',
  B = 'B',
  C = 'C',
  None = 'NONE'
}

export enum VehicleType {
  Atv = 'ATV',
  Bus = 'BUS',
  Motorcycle = 'MOTORCYCLE',
  None = 'NONE',
  Passenger = 'PASSENGER',
  RecVehicle = 'REC_VEHICLE',
  Trailer = 'TRAILER',
  Tricycle = 'TRICYCLE',
  Truck = 'TRUCK'
}

export interface VehicleViewModel {
  blackBookLookupFailed: Scalars['Boolean'];
  eyeColorListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  fuelTypeListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  genderListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  hairColorListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  inLoanAppReview: Scalars['Boolean'];
  initialInputs?: Maybe<VehicleInputModel>;
  isCuro: Scalars['Boolean'];
  legalStatusListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  lienHolderInputs?: Maybe<VehicleLienHolderInputModel>;
  lienHolderListItems?: Maybe<Array<Maybe<StringInt32KeyValuePairGraphType>>>;
  makeListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  modelListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  odometerCodeListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  raceListItems?: Maybe<Array<Maybe<StringStringKeyValuePairGraphType>>>;
  redirect?: Maybe<Scalars['String']>;
  requireEyeColor: Scalars['Boolean'];
  requireGender: Scalars['Boolean'];
  requireHairColor: Scalars['Boolean'];
  requireHeight: Scalars['Boolean'];
  requireRace: Scalars['Boolean'];
  useCondition: Scalars['Boolean'];
  useDirectDeposit: Scalars['Boolean'];
  useFuelType: Scalars['Boolean'];
  useInsuranceCompany: Scalars['Boolean'];
  useLegalStatus: Scalars['Boolean'];
  useLienHolder: Scalars['Boolean'];
  useMileage: Scalars['Boolean'];
  useOdoCode: Scalars['Boolean'];
  usePlate: Scalars['Boolean'];
  useRegistrationDate: Scalars['Boolean'];
  useRegistrationExpires: Scalars['Boolean'];
  useRegistrationState: Scalars['Boolean'];
  useStateNumber: Scalars['Boolean'];
  useStickerNumber: Scalars['Boolean'];
  useTitleNumber: Scalars['Boolean'];
  useVehType: Scalars['Boolean'];
}

export interface ViewStyle {
  float?: Maybe<Scalars['String']>;
  marginBottom?: Maybe<Unit>;
  marginLeft?: Maybe<Unit>;
  marginRight?: Maybe<Unit>;
  marginTop?: Maybe<Unit>;
}

export type GetAccountViewModelQueryVariables = Exact<{
  cashCentralApprovalData: Scalars['String'];
}>;


export type GetAccountViewModelQuery = { getAccountViewModel?: { email?: string, origin: LoanApplicationOrigin, redirectUrl?: string, showInviteExpired: boolean, showSecurityIconsAndMessage: boolean, securityQuestions?: Array<{ key: string, value: number }> } };

export type PersistAccountInputModelMutationVariables = Exact<{
  inputModel: AccountInputModel;
}>;


export type PersistAccountInputModelMutation = { persistAccountInputModel?: { redirectUrl?: string } };

export type PersistReservationInputModelMutationVariables = Exact<{
  inputModel: ReservationInputModel;
}>;


export type PersistReservationInputModelMutation = { persistReservationInputModel?: { reason: PrescreenOfferDetailReason } };

export type ValidateEmailQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type ValidateEmailQuery = { validateEmail?: { isValid: boolean, validationMessage?: string, emailSuggestion?: string } };

export type GetNonMarketLocationMutationVariables = Exact<{ [key: string]: never; }>;


export type GetNonMarketLocationMutation = { getNonMarketLocation: boolean };

export type CreateNewMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateNewMutation = { createNew?: { redirectUrl?: string, hasLoanApplication: boolean } };

export type GetBankVerificationFailOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankVerificationFailOptionsQuery = { getBankVerificationFailOptions?: { canUseElectronicPaystub: boolean, canUsePictureUtility: boolean, incomeNeedsVerified: boolean, loanApplicationKey: number, pictureUtilityDownloadUrl?: string, redirectUrl?: string } };

export type PersistBankVerificationLoginDetailsMutationVariables = Exact<{
  loginId?: InputMaybe<Scalars['String']>;
}>;


export type PersistBankVerificationLoginDetailsMutation = { persistBankVerificationLoginDetails: boolean };

export type GetBankVerificationViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankVerificationViewModelQuery = { getBankVerificationViewModel?: { flinksConnectUrl?: string } };

export type GetBankViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankViewModelQuery = { getBankViewModel?: { bankAccountNumber?: string, bankAccountNumberVerify?: string, bankInstitutionNumber?: string, bankTransitNumber?: string, nameOnCard?: string, bin?: string, bridgePayPermanentToken?: string, canAddCard: boolean, canFundToDebitCard: boolean, cardExpiry?: Date, hasCardOnFile: boolean, inLoanAppReview: boolean, isDebitCardRequired: boolean, lastFour?: string, loanType: LoanType, origin: LoanApplicationOrigin, paperlessBillingEnabled: boolean, redirectUrl?: string, state: State, useHomeAddressForCard: boolean, homeAddress?: { address?: string, city?: string, state?: string, unitNumber?: string, unitType?: string, zip?: string } } };

export type PersistBankInputModelMutationVariables = Exact<{
  inputModel: BankInputModel;
}>;


export type PersistBankInputModelMutation = { persistBankInputModel?: { canAddCard: boolean, redirectUrl?: string, matchedCustomer?: { customerKey: number, email?: string, firstName?: string, lastName?: string, homePhone?: string, numMatches: number, visitorKey: number, socialSecurityNumber?: string, homeAddress?: { address?: string, unitNumber?: string, unitType?: string, city?: string, state?: string, zip?: string } } } };

export type SaveBankInputModelMutationVariables = Exact<{
  inputModel: BankInputModel;
}>;


export type SaveBankInputModelMutation = { saveBankInputModel?: { canAddCard: boolean, redirectUrl?: string, matchedCustomer?: { customerKey: number, email?: string, firstName?: string, lastName?: string, homePhone?: string, numMatches: number, visitorKey: number, socialSecurityNumber?: string, homeAddress?: { address?: string, unitNumber?: string, unitType?: string, city?: string, state?: string, zip?: string } } } };

export type LogBankNotSupportedMutationVariables = Exact<{
  inputModel: BankInputModel;
}>;


export type LogBankNotSupportedMutation = { logBankNotSupported: number };

export type GetBusinessLoanModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessLoanModelQuery = { getBusinessLoanModel?: { redirectUrl?: string, validationMessage?: string, currentAddress?: { address?: string, city?: string, state?: string, unitNumber?: string, unitType?: string, zip?: string } } };

export type PersistBusinessLoanModelMutationVariables = Exact<{
  inputModel: BusinessLoanInputModel;
}>;


export type PersistBusinessLoanModelMutation = { persistBusinessLoanModel?: { redirectUrl?: string } };

export type GetDeniedViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDeniedViewModelQuery = { getDeniedViewModel?: { applyForPaydayLoanUrl?: string, googleMapsApiKey?: string, isNearStore: boolean, isNonMarketState: boolean, isRapidCash: boolean, isRestrictedState: boolean, isStateDeclined: boolean, itemsForStoreLoans?: Array<string>, offerPaydayLoan: boolean, redirectUrl?: string, stateCodeFromApp?: string, stateDeniedText?: string, storeAddressLine1?: string, storeAddressLine2?: string, storeAddressLine3?: string, storeAddressCity?: string, storeAddressState?: string, storeAddressZipCode?: string, storeCrossStreets?: string, storeDirectionsUrl?: string, storeHours?: string, storeLatitude: number, storeLocationsUrl?: string, storeLongitude: number, storeName?: string, storePhone?: string } };

export type ClearDeniedLoanApplicationCacheMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearDeniedLoanApplicationCacheMutation = { clearDeniedLoanApplicationCache?: boolean };

export type GetDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDocumentsQuery = { getDocuments?: { currentState: State, exitPromptEnabled: boolean, fullNameMatch?: string, isInsuredProduct: boolean, phone?: string, refinanceLoanKey: number, signatures?: Array<string>, subheading?: string, redirectUrl?: string, documents?: Array<{ documentIndex: number, images?: Array<string>, isMarketingConsent: boolean, isMilitaryDoc: boolean, name?: string, noSignatureAction: NoSignatureAction, required: boolean, signatureLabel?: string, showSignatureCheckbox: boolean, visible: boolean }>, name?: { firstName?: string, middleName?: string, lastName?: string, initials?: string }, phoneListItems?: Array<{ value?: string, text?: string }> } };

export type SubmitDocumentsMutationVariables = Exact<{
  model: DocumentListModelInput;
}>;


export type SubmitDocumentsMutation = { submitDocuments?: { currentState: State, exitPromptEnabled: boolean, fullNameMatch?: string, isInsuredProduct: boolean, phone?: string, refinanceLoanKey: number, signatures?: Array<string>, subheading?: string, redirectUrl?: string, documents?: Array<{ documentIndex: number, images?: Array<string>, isMarketingConsent: boolean, isMilitaryDoc: boolean, name?: string, noSignatureAction: NoSignatureAction, required: boolean, signatureLabel?: string, showSignatureCheckbox: boolean, visible: boolean }>, name?: { firstName?: string, middleName?: string, lastName?: string, initials?: string }, phoneListItems?: Array<{ value?: string, text?: string }> } };

export type GetCurrentApplicationStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentApplicationStatusQuery = { getCurrentApplicationStatus?: { customerKey: number, isLoanByPhone: boolean, visitorKey: number, loanApplicationKey: number, status: number, scoreResults?: Array<{ hadCreditLock: boolean, isApproved: boolean, isDeniedSRC: boolean, isDeniedState: boolean, isInStateWaitingPeriod: boolean, loanType?: string, maxOverrideTierAmtForScoredProduct: number, pointsNeededForApproval: number, productType?: string, scoreApprovalAmt: number, scoreDescriptions?: Array<string>, scorePoints: number, scoreSummaryKey: number, scoreValues?: Array<number>, stateDBMaxLoanDays: number, creditAgenciesThatDenied?: Array<{ address?: string, city?: string, consumerContactName?: string, creditScore: number, creditScoreBeginRange: number, creditScoreEndRange: number, isCreditReportingAgency: boolean, isCreditScore: boolean, name?: string, phoneNumber?: string, state?: string, websiteAddress?: string, zip?: string, agencyMasterKey: number }>, creditAgencyList?: Array<{ address?: string, city?: string, consumerContactName?: string, creditScore: number, creditScoreBeginRange: number, creditScoreEndRange: number, isCreditReportingAgency: boolean, isCreditScore: boolean, name?: string, phoneNumber?: string, state?: string, websiteAddress?: string, zip?: string, agencyMasterKey: number }>, denialReasonsSRC?: Array<{ key: number, value: string }>, denialReasonsState?: Array<{ key: number, value: string }>, denialReasonsVendor?: Array<{ key: number, value: string }> }> } };

export type GetIdentificationViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdentificationViewModelQuery = { getIdentificationViewModel?: { identificationCountry?: string, identificationExpiry?: Date, identificationNumber?: string, identificationState?: string, identificationTypeKey?: number, isIdentificationNonExpiry: boolean, inLoanAppReview: boolean, origin: LoanApplicationOrigin, redirectUrl?: string, statesWithPotentialNonExpiryId?: Array<string>, countries?: Array<{ key: string, value: string }>, identificationTypes?: Array<{ description?: string, key: number, requireCountry: boolean, requireExpiry: boolean, requireNumber: boolean, requireState: boolean }> } };

export type PersistIdentificationInputModelMutationVariables = Exact<{
  inputModel: IdentificationInputModel;
}>;


export type PersistIdentificationInputModelMutation = { persistIdentificationInputModel?: { redirectUrl?: string } };

export type GetIncomeViewModelQueryVariables = Exact<{
  incomeTypeCode: Scalars['String'];
}>;


export type GetIncomeViewModelQuery = { getIncomeViewModel?: { origin: LoanApplicationOrigin, redirectUrl?: string, incomeSourceOptions?: Array<{ key: string, value: number }>, incomeTypeOptions?: Array<{ key: string, value: string }>, incomeVerificationTypes?: Array<{ key: string, value: number }>, jobTypeOptions?: Array<{ key: string, value: number }>, payCycleOptions?: Array<{ key: string, value: number }>, twiceMonthlyPaydayOptions?: Array<{ key: string, value: number }> } };

export type GetIncomeVerificationMethodsQueryVariables = Exact<{
  incomeVerificationType: Scalars['Int'];
}>;


export type GetIncomeVerificationMethodsQuery = { getIncomeVerificationMethods?: Array<{ key: string, value: number }> };

export type GetLoanApplicationIndividualScheduledPaymentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoanApplicationIndividualScheduledPaymentsQuery = { getLoanApplicationIndividualScheduledPayments?: { enrollAllPayments: boolean, optionalLoanPaymentAuthorizationDocUrl?: string, redirectUrl?: string, name?: { firstName?: string, lastName?: string, initials?: string }, scheduledPayments?: Array<{ amount: number, date: Date, key: number, scheduled: boolean }> } };

export type SubmitLoanApplicationIndividualScheduledPaymentsMutationVariables = Exact<{
  model: IndividualScheduledPaymentsModelInput;
}>;


export type SubmitLoanApplicationIndividualScheduledPaymentsMutation = { submitLoanApplicationIndividualScheduledPayments?: { enrollAllPayments: boolean, optionalLoanPaymentAuthorizationDocUrl?: string, redirectUrl?: string, name?: { firstName?: string, lastName?: string, initials?: string }, scheduledPayments?: Array<{ amount: number, date: Date, key: number, scheduled: boolean }> } };

export type GetLoanProtectionPlanViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoanProtectionPlanViewModelQuery = { getLoanProtectionPlanViewModel?: { isInsuranceOptIn: boolean, isOpenEnd: boolean } };

export type GetOptionalPaymentAuthorizationViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOptionalPaymentAuthorizationViewModelQuery = { getOptionalPaymentAuthorizationViewModel?: { paperlessBillingEnabled: boolean, storeLocationUrl?: string } };

export type PersistOptionalPaymentAuthorizationNoThanksMutationVariables = Exact<{ [key: string]: never; }>;


export type PersistOptionalPaymentAuthorizationNoThanksMutation = { persistOptionalPaymentAuthorizationNoThanks?: { redirectUrl?: string } };

export type OutOfWalletQueryVariables = Exact<{ [key: string]: never; }>;


export type OutOfWalletQuery = { outOfWallet?: { redirectUrl?: string, questions?: Array<{ actualTime: number, answerId: number, questionId: number, text?: string, timePermitted: number, validationMessage?: string, possibleAnswers?: Array<{ text?: string, value?: string }> }> } };

export type OutOfWalletSaveMutationVariables = Exact<{
  model: OutOfWalletSaveRequest;
}>;


export type OutOfWalletSaveMutation = { outOfWalletSave?: { redirectUrl?: string, questions?: Array<{ actualTime: number, answerId: number, questionId: number, text?: string, timePermitted: number, validationMessage?: string, possibleAnswers?: Array<{ text?: string, value?: string }> }> } };

export type GetPendingContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPendingContentQuery = { getPendingContent?: { redirect?: string, content?: Array<{ id: number, parentId?: number, bulletType?: BulletType, type: NodeType, action?: string, icon?: IconType, target?: string, buttonType?: ButtonType, url?: string, height?: number, source?: string, width?: number, text?: string, style?: { float?: string, marginBottom?: { value: number, type?: string }, marginLeft?: { value: number, type?: string }, marginRight?: { value: number, type?: string }, marginTop?: { value: number, type?: string } }, textStyle?: { color?: string, fontStyle: FontStyle, fontWeight: FontWeight, textDecorationLine: TextDecorationLine, marginBottom?: { value: number, type?: string }, marginLeft?: { value: number, type?: string }, marginRight?: { value: number, type?: string }, marginTop?: { value: number, type?: string } } }> } };

export type GetPersonalViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalViewModelQuery = { getPersonalViewModel?: { address?: string, birthDate?: Date, canEditBirthDate: boolean, canEditPersonName: boolean, canEditSocialSecurityNumber: boolean, city?: string, firstName?: string, homePhone?: string, housing?: Housing, inLoanAppReview: boolean, isMilitary?: boolean, lastName?: string, middleName?: string, mobilePhone?: string, origin: LoanApplicationOrigin, requestCommunicationConsentOperational: boolean, requestCommunicationConsentPromotional: boolean, redirectUrl?: string, residenceSince?: Date, socialSecurityNumber?: string, state?: string, unitNumber?: string, unitType?: string, zip?: string, marketingInvitation?: { acceptUrl?: string, cashCentralExistingBalance?: number, declineUrl?: string, displayDecline: boolean, displayReservationCode: boolean, expirationDate: Date, loanProductDescription?: string, preApprovedLoanAmount: number, ratesAndTermsUrl?: string, reservationCode?: string } } };

export type PersistPersonalInputModelMutationVariables = Exact<{
  inputModel: PersonalInputModel;
}>;


export type PersistPersonalInputModelMutation = { persistPersonalInputModel?: { curoMilitaryScoreErrorCount: number, redirectUrl?: string, curoDodDualAuth?: { customerKey: number, loanProductConfigKey: number }, marketingInvitation?: { acceptUrl?: string, cashCentralExistingBalance?: number, declineUrl?: string, displayDecline: boolean, displayReservationCode: boolean, expirationDate: Date, loanProductDescription?: string, preApprovedLoanAmount: number, ratesAndTermsUrl?: string, reservationCode?: string }, matchedCustomer?: { customerKey: number, email?: string, firstName?: string, lastName?: string, homePhone?: string, numMatches: number, visitorKey: number, socialSecurityNumber?: string, homeAddress?: { address?: string, unitNumber?: string, unitType?: string, city?: string, state?: string, zip?: string } } } };

export type PersistCommunicationConsentInputModelMutationVariables = Exact<{
  inputModel: CommunicationConsentInputModel;
}>;


export type PersistCommunicationConsentInputModelMutation = { persistCommunicationConsentInputModel: boolean };

export type SavePersonalInputModelMutationVariables = Exact<{
  inputModel: PersonalInputModel;
}>;


export type SavePersonalInputModelMutation = { savePersonalInputModel?: { curoMilitaryScoreErrorCount: number, redirectUrl?: string, curoDodDualAuth?: { customerKey: number, loanProductConfigKey: number }, marketingInvitation?: { acceptUrl?: string, cashCentralExistingBalance?: number, declineUrl?: string, displayDecline: boolean, displayReservationCode: boolean, expirationDate: Date, loanProductDescription?: string, preApprovedLoanAmount: number, ratesAndTermsUrl?: string, reservationCode?: string }, matchedCustomer?: { customerKey: number, email?: string, firstName?: string, lastName?: string, homePhone?: string, numMatches: number, visitorKey: number, socialSecurityNumber?: string, homeAddress?: { address?: string, unitNumber?: string, unitType?: string, city?: string, state?: string, zip?: string } } } };

export type PreLoanAppDisclosuresMutationVariables = Exact<{
  model: PreLoanAppDisclosuresRequest;
}>;


export type PreLoanAppDisclosuresMutation = { preLoanAppDisclosures?: { province: State, redirectUrl?: string, noProvinceUrl?: string, costComparisonFileName?: string, oNCostComparisonFileName?: string, productType: ProductType } };

export type PreLoanAppDisclosuresRedirectMutationVariables = Exact<{
  model: PreLoanAppDisclosuresRedirectRequest;
}>;


export type PreLoanAppDisclosuresRedirectMutation = { preLoanAppDisclosuresRedirect?: { redirectUrl?: string } };

export type SkPreLoanAppDisclosuresMutationVariables = Exact<{ [key: string]: never; }>;


export type SkPreLoanAppDisclosuresMutation = { skPreLoanAppDisclosures?: { disclosureDownloadUrl?: string, redirectUrl?: string } };

export type SkPreLoanAppDisclosuresRedirectMutationVariables = Exact<{ [key: string]: never; }>;


export type SkPreLoanAppDisclosuresRedirectMutation = { skPreLoanAppDisclosuresRedirect?: { redirectUrl?: string } };

export type ProductSelectionQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductSelectionQuery = { productSelection?: { disclaimers?: Array<string>, exitPromptEnabled: boolean, isRapidCash: boolean, isInStore: boolean, loanProductConfigKey: number, selectProductBeforeApp: boolean, products?: Array<{ annualPercentageRate?: number, disclaimer?: string, howLong?: string, howMuch?: string, insuranceFeeAmount?: number, loanProductConfigKey: number, maximumLoanAmount: number, maximumLoanLengthDays: number, order?: number, paymentAmount?: number, productHeader?: string, productType: ProductType, selectedLoanTerm?: { length: number, termType: TermType } }> } };

export type SaveProductSelectionMutationVariables = Exact<{
  model: ProductSelectionSaveRequest;
}>;


export type SaveProductSelectionMutation = { saveProductSelection?: { redirectUrl?: string, errors?: Array<{ key: string, value: string }> } };

export type GetReviewViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReviewViewModelQuery = { getReviewViewModel?: { accountNumberDisplay?: string, bankName?: string, bankRoutingNumber?: string, businessName?: string, cardExpiry: Date, cardNumberDisplay?: string, cellPhone?: string, enabledAppSections?: Array<LoanApplicationSection>, firstName?: string, homePhone?: string, identificationTypeKey?: number, isBusinessLoan: boolean, lastName?: string, maritalStatus: MaritalStatus, redirectUrl?: string, origin: LoanApplicationOrigin, spouseFirstName?: string, spouseLastName?: string, vehicleIdentificationNumber?: string, vehicleMake?: string, vehicleModel?: string, vehicleYear: number, address?: { address?: string, city?: string, state?: string, unitNumber?: string, unitType?: string, zip?: string }, businessAddress?: { city?: string, state?: string, address?: string, zip?: string }, confirmNoCard?: { canFundToDebitCard: boolean }, incomes?: Array<{ employerName?: string, grossPay?: number, incomeFrequency?: IncomeCalculationCycle, incomeTypeCode?: string, netPay?: number, payCycle: PayCycle, payCycleSummary?: string, workPhone?: string }>, marketingInvitation?: { acceptUrl?: string, declineUrl?: string, displayDecline: boolean, displayReservationCode: boolean, expirationDate: Date, loanProductDescription?: string, preApprovedLoanAmount: number, ratesAndTermsUrl?: string, reservationCode?: string }, spouseAddress?: { address?: string, city?: string, state?: string, unitNumber?: string, unitType?: string, zip?: string }, urls?: Array<{ key: LoanApplicationSection, value: string }>, identificationNumber: number, identificationExpiry: Date,identificationTypeDescription: string, showId: boolean } };

export type PersistReviewInputModelMutationVariables = Exact<{
  inputModel: ReviewInputModel;
}>;


export type PersistReviewInputModelMutation = { persistReviewInputModel?: { redirectUrl?: string } };

export type AppReviewAcceptMarketingInvitationMutationVariables = Exact<{ [key: string]: never; }>;


export type AppReviewAcceptMarketingInvitationMutation = { appReviewAcceptMarketingInvitation?: boolean };

export type AppReviewDeclineMarketingInvitationMutationVariables = Exact<{ [key: string]: never; }>;


export type AppReviewDeclineMarketingInvitationMutation = { appReviewDeclineMarketingInvitation?: boolean };

export type GetDisclosuresQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDisclosuresQuery = { disclosures?: { completingLoanByPhone: boolean, description?: string, inLoanAppReview: boolean, isPendingOrForceApprovedLPP: boolean, isSpanishDocsEnabled: boolean, language: LanguageType, redirectUrl?: string, state: State, stateName?: string, discountCode?: { code?: string, visible: boolean }, disclosures?: Array<{ agree: boolean, content?: string, documentContent?: string, header?: string, help?: string, id?: string, index: number, moreThanOneInstallmentPlan?: string, needsRead?: boolean, required: boolean, requiredValue?: string, selectedValue?: string, subHeader?: string, validation?: string, radioOptions?: Array<{ key: string, value: boolean }> }>, marketingInvitation?: { acceptUrl?: string, declineUrl?: string, displayDecline: boolean, displayReservationCode: boolean, expirationDate: Date, loanProductDescription?: string, preApprovedLoanAmount: number, ratesAndTermsUrl?: string } } };

export type AcceptDisclosuresMutationVariables = Exact<{
  model: ReviewDisclosuresViewModelInput;
}>;


export type AcceptDisclosuresMutation = { acceptDisclosures?: string };

export type ApplyDiscountCodeMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type ApplyDiscountCodeMutation = { applyDiscountCode?: { isValid: boolean, message?: string } };

export type GetScoringOutageModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScoringOutageModelQuery = { getScoringOutageModel?: { nearStore: boolean } };

export type ProcessQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessQuery = { process?: { redirectUrl?: string } };

export type TickMutationVariables = Exact<{ [key: string]: never; }>;


export type TickMutation = { tick?: { redirectUrl?: string, scoringState?: string, processingCountExceeded: boolean } };

export type GetSelectTermsViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSelectTermsViewModelQuery = { getSelectTermsViewModel?: { cashCentralExistingBalance?: number, emailStatements: boolean, exitPromptEnabled: boolean, isInsuredProduct: boolean, isOptedIntoInsurance: boolean, loanHistoryDaysToLookBack: number, maximumLoanAmount: number, minimumLoanAmount: number, payCycle: PayCycle, paymentPlanType: LoanPaymentPlanType, productDescription?: string, productType: ProductType, redirect?: string, requireUserInputAmount: boolean, selectedLoanAmount: number, validLoanAmounts?: Array<number>, canReturnToProductSelection?: boolean, installmentLoanOptions?: Array<{ apr: number, cashAmount: number, loanLength: number, nextDueAmount: number }>, validLoanTerms?: Array<{ length: number, termType: TermType }> } };

export type PersistSelectTermsInputModelMutationVariables = Exact<{
  inputModel: SelectTermsInputModel;
}>;


export type PersistSelectTermsInputModelMutation = { persistSelectTermsInputModel?: string };

export type GetVehicleViewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVehicleViewQuery = { getVehicleView?: { isCuro: boolean, inLoanAppReview: boolean, blackBookLookupFailed: boolean, redirect?: string, requireEyeColor: boolean, requireGender: boolean, requireHairColor: boolean, requireHeight: boolean, requireRace: boolean, useDirectDeposit: boolean, useFuelType: boolean, useInsuranceCompany: boolean, useLegalStatus: boolean, useLienHolder: boolean, useMileage: boolean, useOdoCode: boolean, usePlate: boolean, useRegistrationDate: boolean, useRegistrationExpires: boolean, useRegistrationState: boolean, useStateNumber: boolean, useStickerNumber: boolean, useTitleNumber: boolean, useCondition: boolean, useVehType: boolean, eyeColorListItems?: Array<{ key: string, value: string }>, fuelTypeListItems?: Array<{ key: string, value: string }>, genderListItems?: Array<{ key: string, value: string }>, hairColorListItems?: Array<{ key: string, value: string }>, initialInputs?: { eyeColor?: string, fuelType?: FuelType, gender?: string, hairColor?: string, hasLien?: boolean, heightFeet?: number, heightInches?: number, insuranceCompany?: string, insuranceCompanyPhone?: string, isLeasedVehicle?: boolean, legalStatus?: VehicleLegalStatus, legalStatusFirstname?: string, legalStatusLastname?: string, legalStatusMiddlename?: string, lienAmount?: number, lienHolder?: number, lienHolderCustomName?: string, make?: string, makeOther?: string, mileage?: number, model?: string, modelOther?: string, odometerCode?: VehicleOdometerCode, plate?: string, race?: string, regDateDay?: number, regDateMonth?: number, regDateYear?: number, regExpiryDay?: number, regExpiryMonth?: number, regExpiryYear?: number, registrationState?: string, retailValue?: number, stateCustomerID?: string, sticker?: string, titleNumber?: string, vehicleCondition?: VehicleCondition, vehicleType?: VehicleType, vin?: string, wholesaleValue?: number, year?: number }, legalStatusListItems?: Array<{ key: string, value: string }>, lienHolderListItems?: Array<{ key: string, value: number }>, makeListItems?: Array<{ key: string, value: string }>, modelListItems?: Array<{ key: string, value: string }>, odometerCodeListItems?: Array<{ key: string, value: string }>, raceListItems?: Array<{ key: string, value: string }> } };

export type GetLienHolderListItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLienHolderListItemsQuery = { getVehicleView?: { lienHolderListItems?: Array<{ key: string, value: number }> } };

export type GetVehicleByVinQueryVariables = Exact<{
  vin?: InputMaybe<Scalars['String']>;
}>;


export type GetVehicleByVinQuery = { getVehicleByVin?: { initialInputs?: { make?: string, model?: string, year?: number }, makeListItems?: Array<{ key: string, value: string }>, modelListItems?: Array<{ key: string, value: string }> } };

export type GetVehicleMakeViewQueryVariables = Exact<{
  year: Scalars['Int'];
}>;


export type GetVehicleMakeViewQuery = { getVehicleMakeView?: { makeListItems?: Array<{ key: string, value: string }> } };

export type GetVehicleModelViewQueryVariables = Exact<{
  year: Scalars['Int'];
  make: Scalars['String'];
}>;


export type GetVehicleModelViewQuery = { getVehicleModelView?: { modelListItems?: Array<{ key: string, value: string }> } };

export type GetVehicleValueViewQueryVariables = Exact<{
  year: Scalars['Int'];
  make: Scalars['String'];
  model: Scalars['String'];
  mileage: Scalars['Int'];
}>;


export type GetVehicleValueViewQuery = { getVehicleValueView?: { blackBookLookupFailed: boolean, initialInputs?: { retailValue?: number, wholesaleValue?: number } } };

export type PersistVehicleInputsMutationVariables = Exact<{
  inputs: VehicleInputModelInput;
}>;


export type PersistVehicleInputsMutation = { persistVehicleInputs?: { redirect?: string } };

export type PersistVehicleLienHolderInputsMutationVariables = Exact<{
  inputs: VehicleLienHolderInputModelInput;
}>;


export type PersistVehicleLienHolderInputsMutation = { persistVehicleLienHolderInputs?: { key?: number, redirect?: string } };

export type OverrideOowForTestQueryVariables = Exact<{ [key: string]: never; }>;


export type OverrideOowForTestQuery = { overrideOowForTest?: { bypassOOW: boolean, currentTestType: OutOfWalletTestType, forceResultType?: OutOfWalletForceResultType, testAccountId?: number, forceResultsList?: Array<{ text?: string, value?: string }>, testAccountsList?: Array<{ text?: string, value?: string }> } };

export type PersistOowForTestLoanApplicationMutationVariables = Exact<{
  model: OutOfWalletTestingModelInput;
}>;


export type PersistOowForTestLoanApplicationMutation = { persistOowForTestLoanApplication?: string };

export type PersistOowForTestLoanMutationVariables = Exact<{
  model: OutOfWalletTestingModelInput;
}>;


export type PersistOowForTestLoanMutation = { persistOowForTestLoan?: string };

export type GetPaystubViewModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaystubViewModelQuery = { getPaystubViewModel?: { firstName?: string, lastName?: string, middleName?: string, redirectUrl?: string, checkDate?: { base?: Date, day?: number, month?: number, year?: number }, hireDate?: { base?: Date, day?: number, month?: number, year?: number }, income?: { grossPay?: number, hireDate?: Date, netPay?: number, payCycle?: PayCycle, workAddress?: { address?: string, city?: string, state?: string, unitNumber?: string, unitType?: string, zip?: string } }, payPeriodEnd?: { base?: Date, day?: number, month?: number, year?: number } } };

export type PersistPaystubInputModelMutationVariables = Exact<{
  inputModel: PaystubInputModel;
}>;


export type PersistPaystubInputModelMutation = { persistPaystubInputModel?: { redirectUrl?: string } };

export type AcceptMarketingInvitationMutationVariables = Exact<{
  reservationCode?: InputMaybe<Scalars['String']>;
}>;


export type AcceptMarketingInvitationMutation = { acceptMarketingInvitation?: boolean };

export type DeclineMarketingInvitationMutationVariables = Exact<{
  reservationCode?: InputMaybe<Scalars['String']>;
}>;


export type DeclineMarketingInvitationMutation = { declineMarketingInvitation?: boolean };

export type GetMarketingInvitationModelQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMarketingInvitationModelQuery = { getMarketingInvitationModel?: { acceptUrl?: string, cashCentralExistingBalance?: number, declineUrl?: string, displayDecline: boolean, displayReservationCode: boolean, expirationDate: Date, loanProductDescription?: string, preApprovedLoanAmount: number, ratesAndTermsUrl?: string, reservationCode?: string } };


export class LoanApplicationClient extends BaseClient {
  path = '/graphql/LoanApplication';


      public persistAccountInputModel(inputModel: PersistAccountInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistAccountInputModelMutation>(`mutation PersistAccountInputModel($inputModel: AccountInputModel!) {
    persistAccountInputModel(inputModel: $inputModel) {
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'PersistAccountInputModel');
      }


      public persistReservationInputModel(inputModel: PersistReservationInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistReservationInputModelMutation>(`mutation PersistReservationInputModel($inputModel: ReservationInputModel!) {
    persistReservationInputModel(inputModel: $inputModel) {
        reason
    }
}`, { inputModel }, createRequestInit(signal), 'PersistReservationInputModel');
      }


      public getAccountViewModel(cashCentralApprovalData: GetAccountViewModelQueryVariables['cashCentralApprovalData'], signal?: AbortSignal | RequestInit) {
          return this.request<GetAccountViewModelQuery>(`query GetAccountViewModel($cashCentralApprovalData: String!) {
    getAccountViewModel(cashCentralApprovalData: $cashCentralApprovalData) {
        email
        origin
        redirectUrl
        securityQuestions {
            key
            value
        }
        showInviteExpired
        showSecurityIconsAndMessage
    }
}`, { cashCentralApprovalData }, createRequestInit(signal), 'GetAccountViewModel');
      }


      public validateEmail(email: ValidateEmailQueryVariables['email'], signal?: AbortSignal | RequestInit) {
          return this.request<ValidateEmailQuery>(`query ValidateEmail($email: String) {
    validateEmail(email: $email) {
        isValid
        validationMessage
        emailSuggestion
    }
}`, { email }, createRequestInit(signal), 'ValidateEmail');
      }


      public getNonMarketLocation(signal?: AbortSignal | RequestInit) {
          return this.request<GetNonMarketLocationMutation>(`mutation GetNonMarketLocation {
    getNonMarketLocation
}`, {}, createRequestInit(signal), 'GetNonMarketLocation');
      }


      public createNew(signal?: AbortSignal | RequestInit) {
          return this.request<CreateNewMutation>(`mutation CreateNew {
    createNew {
        redirectUrl
        hasLoanApplication
    }
}`, {}, createRequestInit(signal), 'CreateNew');
      }


      public getBankVerificationFailOptions(signal?: AbortSignal | RequestInit) {
          return this.request<GetBankVerificationFailOptionsQuery>(`query GetBankVerificationFailOptions {
    getBankVerificationFailOptions {
        canUseElectronicPaystub
        canUsePictureUtility
        incomeNeedsVerified
        loanApplicationKey
        pictureUtilityDownloadUrl
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'GetBankVerificationFailOptions');
      }


      public persistBankVerificationLoginDetails(loginId: PersistBankVerificationLoginDetailsMutationVariables['loginId'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistBankVerificationLoginDetailsMutation>(`mutation PersistBankVerificationLoginDetails($loginId: String) {
    persistBankVerificationLoginDetails(loginId: $loginId)
}`, { loginId }, createRequestInit(signal), 'PersistBankVerificationLoginDetails');
      }


      public getBankVerificationViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetBankVerificationViewModelQuery>(`query GetBankVerificationViewModel {
    getBankVerificationViewModel {
        flinksConnectUrl
    }
}`, {}, createRequestInit(signal), 'GetBankVerificationViewModel');
      }


      public persistBankInputModel(inputModel: PersistBankInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistBankInputModelMutation>(`mutation PersistBankInputModel($inputModel: BankInputModel!) {
    persistBankInputModel(inputModel: $inputModel) {
        canAddCard
        redirectUrl
        matchedCustomer {
            customerKey
            email
            firstName
            homeAddress {
                address
                unitNumber
                unitType
                city
                state
                zip
            }
            lastName
            homePhone
            numMatches
            visitorKey
            socialSecurityNumber
        }
    }
}`, { inputModel }, createRequestInit(signal), 'PersistBankInputModel');
      }


      public saveBankInputModel(inputModel: SaveBankInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<SaveBankInputModelMutation>(`mutation SaveBankInputModel($inputModel: BankInputModel!) {
    saveBankInputModel(inputModel: $inputModel) {
        canAddCard
        redirectUrl
        matchedCustomer {
            customerKey
            email
            firstName
            homeAddress {
                address
                unitNumber
                unitType
                city
                state
                zip
            }
            lastName
            homePhone
            numMatches
            visitorKey
            socialSecurityNumber
        }
    }
}`, { inputModel }, createRequestInit(signal), 'SaveBankInputModel');
      }


      public logBankNotSupported(inputModel: LogBankNotSupportedMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<LogBankNotSupportedMutation>(`mutation LogBankNotSupported($inputModel: BankInputModel!) {
    logBankNotSupported(inputModel: $inputModel)
}`, { inputModel }, createRequestInit(signal), 'LogBankNotSupported');
      }


      public getBankViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetBankViewModelQuery>(`query GetBankViewModel {
    getBankViewModel {
        bankAccountNumber
        bankAccountNumberVerify
        bankInstitutionNumber
        bankTransitNumber
        nameOnCard
        bin
        bridgePayPermanentToken
        canAddCard
        canFundToDebitCard
        cardExpiry
        hasCardOnFile
        homeAddress {
            address
            city
            state
            unitNumber
            unitType
            zip
        }
        inLoanAppReview
        isDebitCardRequired
        lastFour
        loanType
        origin
        paperlessBillingEnabled
        redirectUrl
        state
        useHomeAddressForCard
    }
}`, {}, createRequestInit(signal), 'GetBankViewModel');
      }


      public persistBusinessLoanModel(inputModel: PersistBusinessLoanModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistBusinessLoanModelMutation>(`mutation PersistBusinessLoanModel($inputModel: BusinessLoanInputModel!) {
    persistBusinessLoanModel(inputModel: $inputModel) {
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'PersistBusinessLoanModel');
      }


      public getBusinessLoanModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetBusinessLoanModelQuery>(`query GetBusinessLoanModel {
    getBusinessLoanModel {
        currentAddress {
            address
            city
            state
            unitNumber
            unitType
            zip
        }
        redirectUrl
        validationMessage
    }
}`, {}, createRequestInit(signal), 'GetBusinessLoanModel');
      }


      public clearDeniedLoanApplicationCache(signal?: AbortSignal | RequestInit) {
          return this.request<ClearDeniedLoanApplicationCacheMutation>(`mutation ClearDeniedLoanApplicationCache {
    clearDeniedLoanApplicationCache
}`, {}, createRequestInit(signal), 'ClearDeniedLoanApplicationCache');
      }


      public getDeniedViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetDeniedViewModelQuery>(`query GetDeniedViewModel {
    getDeniedViewModel {
        applyForPaydayLoanUrl
        googleMapsApiKey
        isNearStore
        isNonMarketState
        isRapidCash
        isRestrictedState
        isStateDeclined
        itemsForStoreLoans
        offerPaydayLoan
        redirectUrl
        stateCodeFromApp
        stateDeniedText
        storeAddressLine1
        storeAddressLine2
        storeAddressLine3
        storeAddressCity
        storeAddressState
        storeAddressZipCode
        storeCrossStreets
        storeDirectionsUrl
        storeHours
        storeLatitude
        storeLocationsUrl
        storeLongitude
        storeName
        storePhone
    }
}`, {}, createRequestInit(signal), 'GetDeniedViewModel');
      }


      public submitDocuments(model: SubmitDocumentsMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<SubmitDocumentsMutation>(`mutation SubmitDocuments($model: DocumentListModelInput!) {
    submitDocuments(model: $model) {
        currentState
        documents {
            documentIndex
            images
            isMarketingConsent
            isMilitaryDoc
            name
            noSignatureAction
            required
            signatureLabel
            showSignatureCheckbox
            visible
        }
        exitPromptEnabled
        fullNameMatch
        isInsuredProduct
        name {
            firstName
            middleName
            lastName
            initials
        }
        phone
        phoneListItems {
            value
            text
        }
        refinanceLoanKey
        signatures
        subheading
        redirectUrl
    }
}`, { model }, createRequestInit(signal), 'SubmitDocuments');
      }


      public getDocuments(signal?: AbortSignal | RequestInit) {
          return this.request<GetDocumentsQuery>(`query GetDocuments {
    getDocuments {
        currentState
        documents {
            documentIndex
            images
            isMarketingConsent
            isMilitaryDoc
            name
            noSignatureAction
            required
            signatureLabel
            showSignatureCheckbox
            visible
        }
        exitPromptEnabled
        fullNameMatch
        isInsuredProduct
        name {
            firstName
            middleName
            lastName
            initials
        }
        phone
        phoneListItems {
            value
            text
        }
        refinanceLoanKey
        signatures
        subheading
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'GetDocuments');
      }


      public getCurrentApplicationStatus(signal?: AbortSignal | RequestInit) {
          return this.request<GetCurrentApplicationStatusQuery>(`query GetCurrentApplicationStatus {
    getCurrentApplicationStatus {
        customerKey
        isLoanByPhone
        visitorKey
        loanApplicationKey
        status
        scoreResults {
            creditAgenciesThatDenied {
                address
                city
                consumerContactName
                creditScore
                creditScoreBeginRange
                creditScoreEndRange
                isCreditReportingAgency
                isCreditScore
                name
                phoneNumber
                state
                websiteAddress
                zip
                agencyMasterKey
            }
            creditAgencyList {
                address
                city
                consumerContactName
                creditScore
                creditScoreBeginRange
                creditScoreEndRange
                isCreditReportingAgency
                isCreditScore
                name
                phoneNumber
                state
                websiteAddress
                zip
                agencyMasterKey
            }
            denialReasonsSRC {
                key
                value
            }
            denialReasonsState {
                key
                value
            }
            denialReasonsVendor {
                key
                value
            }
            hadCreditLock
            isApproved
            isDeniedSRC
            isDeniedState
            isInStateWaitingPeriod
            loanType
            maxOverrideTierAmtForScoredProduct
            pointsNeededForApproval
            productType
            scoreApprovalAmt
            scoreDescriptions
            scorePoints
            scoreSummaryKey
            scoreValues
            stateDBMaxLoanDays
        }
    }
}`, {}, createRequestInit(signal), 'GetCurrentApplicationStatus');
      }


      public persistIdentificationInputModel(inputModel: PersistIdentificationInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistIdentificationInputModelMutation>(`mutation PersistIdentificationInputModel($inputModel: IdentificationInputModel!) {
    persistIdentificationInputModel(inputModel: $inputModel) {
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'PersistIdentificationInputModel');
      }


      public getIdentificationViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetIdentificationViewModelQuery>(`query GetIdentificationViewModel {
    getIdentificationViewModel {
        countries {
            key
            value
        }
        identificationCountry
        identificationExpiry
        identificationNumber
        identificationState
        identificationTypeKey
        identificationTypes {
            description
            key
            requireCountry
            requireExpiry
            requireNumber
            requireState
        }
        isIdentificationNonExpiry
        inLoanAppReview
        origin
        redirectUrl
        statesWithPotentialNonExpiryId
    }
}`, {}, createRequestInit(signal), 'GetIdentificationViewModel');
      }


      public getIncomeViewModel(incomeTypeCode: GetIncomeViewModelQueryVariables['incomeTypeCode'], signal?: AbortSignal | RequestInit) {
          return this.request<GetIncomeViewModelQuery>(`query GetIncomeViewModel($incomeTypeCode: String!) {
    getIncomeViewModel(incomeTypeCode: $incomeTypeCode) {
        incomeSourceOptions {
            key
            value
        }
        incomeTypeOptions {
            key
            value
        }
        incomeVerificationTypes {
            key
            value
        }
        jobTypeOptions {
            key
            value
        }
        origin
        payCycleOptions {
            key
            value
        }
        redirectUrl
        twiceMonthlyPaydayOptions {
            key
            value
        }
    }
}`, { incomeTypeCode }, createRequestInit(signal), 'GetIncomeViewModel');
      }


      public getIncomeVerificationMethods(incomeVerificationType: GetIncomeVerificationMethodsQueryVariables['incomeVerificationType'], signal?: AbortSignal | RequestInit) {
          return this.request<GetIncomeVerificationMethodsQuery>(`query GetIncomeVerificationMethods($incomeVerificationType: Int!) {
    getIncomeVerificationMethods(incomeVerificationType: $incomeVerificationType) {
        key
        value
    }
}`, { incomeVerificationType }, createRequestInit(signal), 'GetIncomeVerificationMethods');
      }


      public submitLoanApplicationIndividualScheduledPayments(model: SubmitLoanApplicationIndividualScheduledPaymentsMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<SubmitLoanApplicationIndividualScheduledPaymentsMutation>(`mutation SubmitLoanApplicationIndividualScheduledPayments($model: IndividualScheduledPaymentsModelInput!) {
    submitLoanApplicationIndividualScheduledPayments(model: $model) {
        enrollAllPayments
        name {
            firstName
            lastName
            initials
        }
        optionalLoanPaymentAuthorizationDocUrl
        redirectUrl
        scheduledPayments {
            amount
            date
            key
            scheduled
        }
    }
}`, { model }, createRequestInit(signal), 'SubmitLoanApplicationIndividualScheduledPayments');
      }


      public getLoanApplicationIndividualScheduledPayments(signal?: AbortSignal | RequestInit) {
          return this.request<GetLoanApplicationIndividualScheduledPaymentsQuery>(`query GetLoanApplicationIndividualScheduledPayments {
    getLoanApplicationIndividualScheduledPayments {
        enrollAllPayments
        name {
            firstName
            lastName
            initials
        }
        optionalLoanPaymentAuthorizationDocUrl
        redirectUrl
        scheduledPayments {
            amount
            date
            key
            scheduled
        }
    }
}`, {}, createRequestInit(signal), 'GetLoanApplicationIndividualScheduledPayments');
      }


      public getLoanProtectionPlanViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetLoanProtectionPlanViewModelQuery>(`query GetLoanProtectionPlanViewModel {
    getLoanProtectionPlanViewModel {
        isInsuranceOptIn
        isOpenEnd
    }
}`, {}, createRequestInit(signal), 'GetLoanProtectionPlanViewModel');
      }


      public persistOptionalPaymentAuthorizationNoThanks(signal?: AbortSignal | RequestInit) {
          return this.request<PersistOptionalPaymentAuthorizationNoThanksMutation>(`mutation PersistOptionalPaymentAuthorizationNoThanks {
    persistOptionalPaymentAuthorizationNoThanks {
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'PersistOptionalPaymentAuthorizationNoThanks');
      }


      public getOptionalPaymentAuthorizationViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetOptionalPaymentAuthorizationViewModelQuery>(`query GetOptionalPaymentAuthorizationViewModel {
    getOptionalPaymentAuthorizationViewModel {
        paperlessBillingEnabled
        storeLocationUrl
    }
}`, {}, createRequestInit(signal), 'GetOptionalPaymentAuthorizationViewModel');
      }


      public outOfWalletSave(model: OutOfWalletSaveMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<OutOfWalletSaveMutation>(`mutation OutOfWalletSave($model: OutOfWalletSaveRequest!) {
    outOfWalletSave(model: $model) {
        questions {
            actualTime
            answerId
            possibleAnswers {
                text
                value
            }
            questionId
            text
            timePermitted
            validationMessage
        }
        redirectUrl
    }
}`, { model }, createRequestInit(signal), 'OutOfWalletSave');
      }


      public outOfWallet(signal?: AbortSignal | RequestInit) {
          return this.request<OutOfWalletQuery>(`query OutOfWallet {
    outOfWallet {
        questions {
            actualTime
            answerId
            possibleAnswers {
                text
                value
            }
            questionId
            text
            timePermitted
            validationMessage
        }
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'OutOfWallet');
      }


      public getPendingContent(signal?: AbortSignal | RequestInit) {
          return this.request<GetPendingContentQuery>(`query GetPendingContent {
    getPendingContent {
        redirect
        content {
            id
            parentId
            bulletType
            type
            action
            icon
            style {
                float
                marginBottom {
                    value
                    type
                }
                marginLeft {
                    value
                    type
                }
                marginRight {
                    value
                    type
                }
                marginTop {
                    value
                    type
                }
            }
            target
            buttonType
            url

            height
            source
            width

            textStyle {
                color
                fontStyle
                fontWeight
                marginBottom {
                    value
                    type
                }
                marginLeft {
                    value
                    type
                }
                marginRight {
                    value
                    type
                }
                marginTop {
                    value
                    type
                }
                textDecorationLine
            }
            text
        }
    }
}`, {}, createRequestInit(signal), 'GetPendingContent');
      }


      public persistPersonalInputModel(inputModel: PersistPersonalInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistPersonalInputModelMutation>(`mutation PersistPersonalInputModel($inputModel: PersonalInputModel!) {
    persistPersonalInputModel(inputModel: $inputModel) {
        curoDodDualAuth {
            customerKey
            loanProductConfigKey
        }
        curoMilitaryScoreErrorCount
        marketingInvitation {
            acceptUrl
            cashCentralExistingBalance
            declineUrl
            displayDecline
            displayReservationCode
            expirationDate
            loanProductDescription
            preApprovedLoanAmount
            ratesAndTermsUrl
            reservationCode
        }
        matchedCustomer {
            customerKey
            email
            firstName
            homeAddress {
                address
                unitNumber
                unitType
                city
                state
                zip
            }
            lastName
            homePhone
            numMatches
            visitorKey
            socialSecurityNumber
        }
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'PersistPersonalInputModel');
      }


      public persistCommunicationConsentInputModel(inputModel: PersistCommunicationConsentInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistCommunicationConsentInputModelMutation>(`mutation PersistCommunicationConsentInputModel($inputModel: CommunicationConsentInputModel!) {
    persistCommunicationConsentInputModel(inputModel: $inputModel)
}`, { inputModel }, createRequestInit(signal), 'PersistCommunicationConsentInputModel');
      }


      public savePersonalInputModel(inputModel: SavePersonalInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<SavePersonalInputModelMutation>(`mutation SavePersonalInputModel($inputModel: PersonalInputModel!) {
    savePersonalInputModel(inputModel: $inputModel) {
        curoDodDualAuth {
            customerKey
            loanProductConfigKey
        }
        curoMilitaryScoreErrorCount
        marketingInvitation {
            acceptUrl
            cashCentralExistingBalance
            declineUrl
            displayDecline
            displayReservationCode
            expirationDate
            loanProductDescription
            preApprovedLoanAmount
            ratesAndTermsUrl
            reservationCode
        }
        matchedCustomer {
            customerKey
            email
            firstName
            homeAddress {
                address
                unitNumber
                unitType
                city
                state
                zip
            }
            lastName
            homePhone
            numMatches
            visitorKey
            socialSecurityNumber
        }
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'SavePersonalInputModel');
      }


      public getPersonalViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetPersonalViewModelQuery>(`query GetPersonalViewModel {
    getPersonalViewModel {
        address
        birthDate
        canEditBirthDate
        canEditPersonName
        canEditSocialSecurityNumber
        city
        firstName
        homePhone
        housing
        inLoanAppReview
        isMilitary
        lastName
        marketingInvitation {
            acceptUrl
            cashCentralExistingBalance
            declineUrl
            displayDecline
            displayReservationCode
            expirationDate
            loanProductDescription
            preApprovedLoanAmount
            ratesAndTermsUrl
            reservationCode
        }
        middleName
        mobilePhone
        origin
        requestCommunicationConsentOperational
        requestCommunicationConsentPromotional
        redirectUrl
        residenceSince
        socialSecurityNumber
        state
        unitNumber
        unitType
        zip
    }
}`, {}, createRequestInit(signal), 'GetPersonalViewModel');
      }


      public preLoanAppDisclosures(model: PreLoanAppDisclosuresMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<PreLoanAppDisclosuresMutation>(`mutation PreLoanAppDisclosures($model: PreLoanAppDisclosuresRequest!) {
    preLoanAppDisclosures(model: $model) {
        province
        redirectUrl
        noProvinceUrl
        costComparisonFileName
        oNCostComparisonFileName
        productType
    }
}`, { model }, createRequestInit(signal), 'PreLoanAppDisclosures');
      }


      public preLoanAppDisclosuresRedirect(model: PreLoanAppDisclosuresRedirectMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<PreLoanAppDisclosuresRedirectMutation>(`mutation PreLoanAppDisclosuresRedirect($model: PreLoanAppDisclosuresRedirectRequest!) {
    preLoanAppDisclosuresRedirect(model: $model) {
        redirectUrl
    }
}`, { model }, createRequestInit(signal), 'PreLoanAppDisclosuresRedirect');
      }


      public skPreLoanAppDisclosures(signal?: AbortSignal | RequestInit) {
          return this.request<SkPreLoanAppDisclosuresMutation>(`mutation SkPreLoanAppDisclosures {
    skPreLoanAppDisclosures {
        disclosureDownloadUrl
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'SkPreLoanAppDisclosures');
      }


      public skPreLoanAppDisclosuresRedirect(signal?: AbortSignal | RequestInit) {
          return this.request<SkPreLoanAppDisclosuresRedirectMutation>(`mutation SkPreLoanAppDisclosuresRedirect {
    skPreLoanAppDisclosuresRedirect {
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'SkPreLoanAppDisclosuresRedirect');
      }


      public saveProductSelection(model: SaveProductSelectionMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<SaveProductSelectionMutation>(`mutation SaveProductSelection($model: ProductSelectionSaveRequest!) {
    saveProductSelection(model: $model) {
        redirectUrl
        errors {
            key
            value
        }
    }
}`, { model }, createRequestInit(signal), 'SaveProductSelection');
      }


      public productSelection(signal?: AbortSignal | RequestInit) {
          return this.request<ProductSelectionQuery>(`query ProductSelection {
    productSelection {
        disclaimers
        exitPromptEnabled
        isRapidCash
        isInStore
        loanProductConfigKey
        selectProductBeforeApp
        products {
            annualPercentageRate
            disclaimer
            howLong
            howMuch
            insuranceFeeAmount
            loanProductConfigKey
            maximumLoanAmount
            maximumLoanLengthDays
            order
            paymentAmount
            productHeader
            productType
            selectedLoanTerm {
                length
                termType
            }
        }
        selectProductBeforeApp
    }
}`, {}, createRequestInit(signal), 'ProductSelection');
      }


      public persistReviewInputModel(inputModel: PersistReviewInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistReviewInputModelMutation>(`mutation PersistReviewInputModel($inputModel: ReviewInputModel!) {
    persistReviewInputModel(inputModel: $inputModel) {
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'PersistReviewInputModel');
      }


      public appReviewAcceptMarketingInvitation(signal?: AbortSignal | RequestInit) {
          return this.request<AppReviewAcceptMarketingInvitationMutation>(`mutation AppReviewAcceptMarketingInvitation {
    appReviewAcceptMarketingInvitation
}`, {}, createRequestInit(signal), 'AppReviewAcceptMarketingInvitation');
      }


      public appReviewDeclineMarketingInvitation(signal?: AbortSignal | RequestInit) {
          return this.request<AppReviewDeclineMarketingInvitationMutation>(`mutation AppReviewDeclineMarketingInvitation {
    appReviewDeclineMarketingInvitation
}`, {}, createRequestInit(signal), 'AppReviewDeclineMarketingInvitation');
      }


      public getReviewViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetReviewViewModelQuery>(`query GetReviewViewModel {
    getReviewViewModel {
        accountNumberDisplay
        address {
            address
            city
            state
            unitNumber
            unitType
            zip
        }
        bankName
        bankRoutingNumber
        businessName
        businessAddress {
            city
            state
            address
            zip
        }
        cardExpiry
        cardNumberDisplay
        cellPhone
        confirmNoCard {
            canFundToDebitCard
        }
        enabledAppSections
        firstName
        homePhone
        identificationTypeKey
        identificationTypeDescription
        identificationNumber
        identificationExpiry
        showId
        incomes {
            employerName
            grossPay
            incomeFrequency
            incomeTypeCode
            netPay
            payCycle
            payCycleSummary
            workPhone
        }
        isBusinessLoan
        lastName
        maritalStatus
        redirectUrl
        marketingInvitation {
            acceptUrl
            declineUrl
            displayDecline
            displayReservationCode
            expirationDate
            loanProductDescription
            preApprovedLoanAmount
            ratesAndTermsUrl
            reservationCode
        }
        origin
        spouseAddress {
            address
            city
            state
            unitNumber
            unitType
            zip
        }
        spouseFirstName
        spouseLastName
        urls {
            key
            value
        }
        vehicleIdentificationNumber
        vehicleMake
        vehicleModel
        vehicleYear
    }
}`, {}, createRequestInit(signal), 'GetReviewViewModel');
      }


      public acceptDisclosures(model: AcceptDisclosuresMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<AcceptDisclosuresMutation>(`mutation AcceptDisclosures($model: ReviewDisclosuresViewModelInput!) {
    acceptDisclosures(model: $model)
}`, { model }, createRequestInit(signal), 'AcceptDisclosures');
      }


      public applyDiscountCode(code: ApplyDiscountCodeMutationVariables['code'], signal?: AbortSignal | RequestInit) {
          return this.request<ApplyDiscountCodeMutation>(`mutation ApplyDiscountCode($code: String!) {
    applyDiscountCode(code: $code) {
        isValid
        message
    }
}`, { code }, createRequestInit(signal), 'ApplyDiscountCode');
      }


      public getDisclosures(signal?: AbortSignal | RequestInit) {
          return this.request<GetDisclosuresQuery>(`query GetDisclosures {
    disclosures {
        completingLoanByPhone
        description
        discountCode {
            code
            visible
        }
        disclosures {
            agree
            content
            documentContent
            header
            help
            id
            index
            moreThanOneInstallmentPlan
            needsRead
            radioOptions {
                key
                value
            }
            required
            requiredValue
            selectedValue
            subHeader
            validation
        }
        inLoanAppReview
        isPendingOrForceApprovedLPP
        isSpanishDocsEnabled
        language
        marketingInvitation {
            acceptUrl
            declineUrl
            displayDecline
            displayReservationCode
            expirationDate
            loanProductDescription
            preApprovedLoanAmount
            ratesAndTermsUrl
        }
        redirectUrl
        state
        stateName
    }
}`, {}, createRequestInit(signal), 'GetDisclosures');
      }


      public tick(signal?: AbortSignal | RequestInit) {
          return this.request<TickMutation>(`mutation Tick {
    tick {
        redirectUrl
        scoringState
        processingCountExceeded
    }
}`, {}, createRequestInit(signal), 'Tick');
      }


      public getScoringOutageModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetScoringOutageModelQuery>(`query GetScoringOutageModel {
    getScoringOutageModel {
        nearStore
    }
}`, {}, createRequestInit(signal), 'GetScoringOutageModel');
      }


      public process(signal?: AbortSignal | RequestInit) {
          return this.request<ProcessQuery>(`query Process {
    process {
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'Process');
      }


      public persistSelectTermsInputModel(inputModel: PersistSelectTermsInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistSelectTermsInputModelMutation>(`mutation PersistSelectTermsInputModel($inputModel: SelectTermsInputModel!) {
    persistSelectTermsInputModel(inputModel: $inputModel)
}`, { inputModel }, createRequestInit(signal), 'PersistSelectTermsInputModel');
      }


      public getSelectTermsViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetSelectTermsViewModelQuery>(`query GetSelectTermsViewModel {
    getSelectTermsViewModel {
        cashCentralExistingBalance
        emailStatements
        exitPromptEnabled
        installmentLoanOptions {
            apr
            cashAmount
            loanLength
            nextDueAmount
        }
        isInsuredProduct
        isOptedIntoInsurance
        loanHistoryDaysToLookBack
        maximumLoanAmount
        minimumLoanAmount
        payCycle
        paymentPlanType
        productDescription
        productType
        redirect
        requireUserInputAmount
        selectedLoanAmount
        validLoanAmounts
        validLoanTerms {
            length
            termType
        }
        canReturnToProductSelection
    }
}`, {}, createRequestInit(signal), 'GetSelectTermsViewModel');
      }


      public persistVehicleInputs(inputs: PersistVehicleInputsMutationVariables['inputs'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistVehicleInputsMutation>(`mutation PersistVehicleInputs($inputs: VehicleInputModelInput!) {
    persistVehicleInputs(inputs: $inputs) {
        redirect
    }
}`, { inputs }, createRequestInit(signal), 'PersistVehicleInputs');
      }


      public persistVehicleLienHolderInputs(inputs: PersistVehicleLienHolderInputsMutationVariables['inputs'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistVehicleLienHolderInputsMutation>(`mutation PersistVehicleLienHolderInputs($inputs: VehicleLienHolderInputModelInput!) {
    persistVehicleLienHolderInputs(inputs: $inputs) {
        key
        redirect
    }
}`, { inputs }, createRequestInit(signal), 'PersistVehicleLienHolderInputs');
      }


      public getVehicleView(signal?: AbortSignal | RequestInit) {
          return this.request<GetVehicleViewQuery>(`query GetVehicleView {
    getVehicleView {
        eyeColorListItems {
            key
            value
        }
        fuelTypeListItems {
            key
            value
        }
        genderListItems {
            key
            value
        }
        hairColorListItems {
            key
            value
        }
        initialInputs {
            eyeColor
            fuelType
            gender
            hairColor
            hasLien
            heightFeet
            heightInches
            insuranceCompany
            insuranceCompanyPhone
            isLeasedVehicle
            legalStatus
            legalStatusFirstname
            legalStatusLastname
            legalStatusMiddlename
            lienAmount
            lienHolder
            lienHolderCustomName
            make
            makeOther
            mileage
            model
            modelOther
            odometerCode
            plate
            race
            regDateDay
            regDateMonth
            regDateYear
            regExpiryDay
            regExpiryMonth
            regExpiryYear
            registrationState
            retailValue
            stateCustomerID
            sticker
            titleNumber
            vehicleCondition
            vehicleType
            vin
            wholesaleValue
            year
        }
        isCuro
        inLoanAppReview
        blackBookLookupFailed
        legalStatusListItems {
            key
            value
        }
        lienHolderListItems {
            key
            value
        }
        makeListItems {
            key
            value
        }
        modelListItems {
            key
            value
        }
        odometerCodeListItems {
            key
            value
        }
        raceListItems {
            key
            value
        }
        redirect
        requireEyeColor
        requireGender
        requireHairColor
        requireHeight
        requireRace
        useDirectDeposit
        useFuelType
        useInsuranceCompany
        useLegalStatus
        useLienHolder
        useMileage
        useOdoCode
        usePlate
        useRegistrationDate
        useRegistrationExpires
        useRegistrationState
        useStateNumber
        useStickerNumber
        useTitleNumber
        useCondition
        useVehType
    }
}`, {}, createRequestInit(signal), 'GetVehicleView');
      }


      public getLienHolderListItems(signal?: AbortSignal | RequestInit) {
          return this.request<GetLienHolderListItemsQuery>(`query GetLienHolderListItems {
    getVehicleView {
        lienHolderListItems {
            key
            value
        }
    }
}`, {}, createRequestInit(signal), 'GetLienHolderListItems');
      }


      public getVehicleByVin(vin: GetVehicleByVinQueryVariables['vin'], signal?: AbortSignal | RequestInit) {
          return this.request<GetVehicleByVinQuery>(`query GetVehicleByVin($vin: String) {
    getVehicleByVin(vin: $vin) {
        initialInputs {
            make
            model
            year
        }
        makeListItems {
            key
            value
        }
        modelListItems {
            key
            value
        }
    }
}`, { vin }, createRequestInit(signal), 'GetVehicleByVin');
      }


      public getVehicleMakeView(year: GetVehicleMakeViewQueryVariables['year'], signal?: AbortSignal | RequestInit) {
          return this.request<GetVehicleMakeViewQuery>(`query GetVehicleMakeView($year: Int!) {
    getVehicleMakeView(year: $year) {
        makeListItems {
            key
            value
        }
    }
}`, { year }, createRequestInit(signal), 'GetVehicleMakeView');
      }


      public getVehicleModelView(year: GetVehicleModelViewQueryVariables['year'], make: GetVehicleModelViewQueryVariables['make'], signal?: AbortSignal | RequestInit) {
          return this.request<GetVehicleModelViewQuery>(`query GetVehicleModelView($year: Int!, $make: String!) {
    getVehicleModelView(year: $year, make: $make) {
        modelListItems {
            key
            value
        }
    }
}`, { year,make }, createRequestInit(signal), 'GetVehicleModelView');
      }


      public getVehicleValueView(year: GetVehicleValueViewQueryVariables['year'], make: GetVehicleValueViewQueryVariables['make'], model: GetVehicleValueViewQueryVariables['model'], mileage: GetVehicleValueViewQueryVariables['mileage'], signal?: AbortSignal | RequestInit) {
          return this.request<GetVehicleValueViewQuery>(`query GetVehicleValueView($year: Int!, $make: String!, $model: String!, $mileage: Int!) {
    getVehicleValueView(year: $year, make: $make, model: $model, mileage: $mileage) {
        initialInputs {
            retailValue
            wholesaleValue
        }
        blackBookLookupFailed
    }
}`, { year,make,model,mileage }, createRequestInit(signal), 'GetVehicleValueView');
      }


      public persistOowForTestLoanApplication(model: PersistOowForTestLoanApplicationMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistOowForTestLoanApplicationMutation>(`mutation PersistOowForTestLoanApplication($model: OutOfWalletTestingModelInput!) {
    persistOowForTestLoanApplication(model: $model)
}`, { model }, createRequestInit(signal), 'PersistOowForTestLoanApplication');
      }


      public persistOowForTestLoan(model: PersistOowForTestLoanMutationVariables['model'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistOowForTestLoanMutation>(`mutation PersistOowForTestLoan($model: OutOfWalletTestingModelInput!) {
    persistOowForTestLoan(model: $model)
}`, { model }, createRequestInit(signal), 'PersistOowForTestLoan');
      }


      public overrideOowForTest(signal?: AbortSignal | RequestInit) {
          return this.request<OverrideOowForTestQuery>(`query OverrideOowForTest {
    overrideOowForTest {
        bypassOOW
        currentTestType
        forceResultsList {
            text
            value
        }
        forceResultType
        testAccountId
        testAccountsList {
            text
            value
        }
    }
}`, {}, createRequestInit(signal), 'OverrideOowForTest');
      }


      public persistPaystubInputModel(inputModel: PersistPaystubInputModelMutationVariables['inputModel'], signal?: AbortSignal | RequestInit) {
          return this.request<PersistPaystubInputModelMutation>(`mutation PersistPaystubInputModel($inputModel: PaystubInputModel!) {
    persistPaystubInputModel(inputModel: $inputModel) {
        redirectUrl
    }
}`, { inputModel }, createRequestInit(signal), 'PersistPaystubInputModel');
      }


      public getPaystubViewModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetPaystubViewModelQuery>(`query GetPaystubViewModel {
    getPaystubViewModel {
        checkDate {
            base
            day
            month
            year
        }
        firstName
        hireDate {
            base
            day
            month
            year
        }
        income {
            grossPay
            hireDate
            netPay
            payCycle
            workAddress {
                address
                city
                state
                unitNumber
                unitType
                zip
            }
        }
        lastName
        middleName
        payPeriodEnd {
            base
            day
            month
            year
        }
        redirectUrl
    }
}`, {}, createRequestInit(signal), 'GetPaystubViewModel');
      }


      public acceptMarketingInvitation(reservationCode: AcceptMarketingInvitationMutationVariables['reservationCode'], signal?: AbortSignal | RequestInit) {
          return this.request<AcceptMarketingInvitationMutation>(`mutation AcceptMarketingInvitation($reservationCode: String) {
    acceptMarketingInvitation(reservationCode: $reservationCode)
}`, { reservationCode }, createRequestInit(signal), 'AcceptMarketingInvitation');
      }


      public declineMarketingInvitation(reservationCode: DeclineMarketingInvitationMutationVariables['reservationCode'], signal?: AbortSignal | RequestInit) {
          return this.request<DeclineMarketingInvitationMutation>(`mutation DeclineMarketingInvitation($reservationCode: String) {
    declineMarketingInvitation(reservationCode: $reservationCode)
}`, { reservationCode }, createRequestInit(signal), 'DeclineMarketingInvitation');
      }


      public getMarketingInvitationModel(signal?: AbortSignal | RequestInit) {
          return this.request<GetMarketingInvitationModelQuery>(`query GetMarketingInvitationModel {
    getMarketingInvitationModel {
        acceptUrl
        cashCentralExistingBalance
        declineUrl
        displayDecline
        displayReservationCode
        expirationDate
        loanProductDescription
        preApprovedLoanAmount
        ratesAndTermsUrl
        reservationCode
    }
}`, {}, createRequestInit(signal), 'GetMarketingInvitationModel');
      }

}